/**
 * The recorded turns — GENERATED, do not hand-edit.
 *
 * Produced by ~/march-demo-data/build-fixture.py from the SSE streams captured
 * when these five questions were asked against the live dev agent. The answer
 * text, the structured cards, the follow-up chips, the retrieved sources and
 * the timings are all the product's own output, embedded verbatim: re-typing
 * them is how a demo ends up quoting something the system never said.
 *
 * To refresh: re-run ~/march-demo-pull.sh, then build-fixture.py.
 */

/* eslint-disable */
export interface GeneratedTurn {
  id: string;
  question: string;
  answer: string;
  intent_type?: string | null;
  tools_used: string[];
  processing_time_ms?: number | null;
  thinking_event_count: number;
  suggestions: string[];
  structured?: Record<string, unknown>;
  rag_sources?: Array<Record<string, unknown>>;
  guideline_evidence?: Record<string, unknown>;
  specialty_outputs?: Array<Record<string, unknown>>;
  engaged_specialties?: string[];
  router_overview?: string;
}

export const GENERATED_TURNS: GeneratedTurn[] = [
  {
    "id": "bp",
    "question": "What is the trend in this patient's BP?",
    "answer": "There are 106 dated values on record across 1 measurement. Diastolic blood pressure shows a decreasing trend, moving from 82 mm[Hg] on 1946-07-11 to 58 mm[Hg] on 2026-07-16. The pattern is a mostly decrease, characterized by long periods of relative stability punctuated by fluctuations, including a peak of 109 mm[Hg] in 2014-10-23 before the long-term downward trajectory.",
    "intent_type": "data_query",
    "tools_used": [
      "get_observations"
    ],
    "processing_time_ms": 12628,
    "thinking_event_count": 19,
    "suggestions": [
      "Show her chart overview",
      "Show her active medications",
      "Show her active conditions"
    ],
    "structured": {
      "response_type": "narrative_summary_card",
      "title": "Repeated measurements with trend interpretation",
      "subtitle": "Sequence-based clinical trend review",
      "sections": [
        {
          "type": "paragraph",
          "title": "Diastolic Blood Pressure — interpretation",
          "content": "**Diastolic Blood Pressure** (LOINC: 8462-4)\n\nValues reviewed: 106 (1946-07-11 to 2026-07-16)\nDiastolic blood pressure shows a decreasing trend, moving from 82 mm[Hg] on 1946-07-11 to 58 mm[Hg] on 2026-07-16. The pattern is a mostly decrease, characterized by long periods of relative stability punctuated by fluctuations, including a peak of 109 mm[Hg] in 2014-10-23 before the long-term downward trajectory.",
          "meta": {
            "block_type": "TREND_CANDIDATE_SUMMARY",
            "trend_candidate_summary": true
          },
          "presentation": {
            "layout": "narrative",
            "density": "comfortable",
            "font_scale": "md",
            "separators": true
          }
        },
        {
          "type": "table",
          "title": "Diastolic Blood Pressure — chronological values",
          "columns": [
            "Date",
            "Value"
          ],
          "rows": [
            {
              "date": "1946-07-11",
              "value": "82 mm[Hg]"
            },
            {
              "date": "1946-08-15",
              "value": "82 mm[Hg]"
            },
            {
              "date": "1946-10-17",
              "value": "82 mm[Hg]"
            },
            {
              "date": "1946-12-19",
              "value": "80 mm[Hg]"
            },
            {
              "date": "1947-03-20",
              "value": "80 mm[Hg]"
            },
            {
              "date": "1947-06-19",
              "value": "77 mm[Hg]"
            },
            {
              "date": "1947-09-18",
              "value": "80 mm[Hg]"
            },
            {
              "date": "1947-12-18",
              "value": "82 mm[Hg]"
            },
            {
              "date": "1948-06-17",
              "value": "75 mm[Hg]"
            },
            {
              "date": "1948-12-16",
              "value": "81 mm[Hg]"
            },
            {
              "date": "1949-06-16",
              "value": "81 mm[Hg]"
            },
            {
              "date": "1949-12-15",
              "value": "78 mm[Hg]"
            },
            {
              "date": "1950-06-15",
              "value": "78 mm[Hg]"
            },
            {
              "date": "1950-12-28",
              "value": "81 mm[Hg]"
            },
            {
              "date": "1951-06-21",
              "value": "81 mm[Hg]"
            },
            {
              "date": "1952-06-26",
              "value": "73 mm[Hg]"
            },
            {
              "date": "1953-03-26",
              "value": "75 mm[Hg]"
            },
            {
              "date": "1953-07-02",
              "value": "77 mm[Hg]"
            },
            {
              "date": "1954-07-08",
              "value": "81 mm[Hg]"
            },
            {
              "date": "1955-07-14",
              "value": "72 mm[Hg]"
            },
            {
              "date": "1956-07-19",
              "value": "79 mm[Hg]"
            },
            {
              "date": "1957-07-25",
              "value": "80 mm[Hg]"
            },
            {
              "date": "1958-07-31",
              "value": "73 mm[Hg]"
            },
            {
              "date": "1959-08-06",
              "value": "80 mm[Hg]"
            },
            {
              "date": "1960-08-11",
              "value": "81 mm[Hg]"
            },
            {
              "date": "1961-08-17",
              "value": "81 mm[Hg]"
            },
            {
              "date": "1962-08-23",
              "value": "82 mm[Hg]"
            },
            {
              "date": "1963-06-04",
              "value": "95.551 mm[Hg]"
            },
            {
              "date": "1963-08-29",
              "value": "68 mm[Hg]"
            },
            {
              "date": "1964-09-03",
              "value": "78 mm[Hg]"
            },
            {
              "date": "1965-09-09",
              "value": "82 mm[Hg]"
            },
            {
              "date": "1968-09-12",
              "value": "79 mm[Hg]"
            },
            {
              "date": "1971-09-16",
              "value": "96 mm[Hg]"
            },
            {
              "date": "1974-09-19",
              "value": "84 mm[Hg]"
            },
            {
              "date": "1977-09-22",
              "value": "84 mm[Hg]"
            },
            {
              "date": "1980-09-25",
              "value": "85 mm[Hg]"
            },
            {
              "date": "1983-09-29",
              "value": "83 mm[Hg]"
            },
            {
              "date": "1986-07-17",
              "value": "84 mm[Hg]"
            },
            {
              "date": "1988-07-21",
              "value": "97 mm[Hg]"
            },
            {
              "date": "1990-07-26",
              "value": "84 mm[Hg]"
            },
            {
              "date": "1990-08-09",
              "value": "88 mm[Hg]"
            },
            {
              "date": "1992-07-30",
              "value": "92 mm[Hg]"
            },
            {
              "date": "1994-08-04",
              "value": "86 mm[Hg]"
            },
            {
              "date": "1996-03-28",
              "value": "83 mm[Hg]"
            },
            {
              "date": "1996-07-11",
              "value": "89 mm[Hg]"
            },
            {
              "date": "1997-07-17",
              "value": "88 mm[Hg]"
            },
            {
              "date": "1998-07-23",
              "value": "87 mm[Hg]"
            },
            {
              "date": "1999-07-29",
              "value": "89 mm[Hg]"
            },
            {
              "date": "2000-08-03",
              "value": "91 mm[Hg]"
            },
            {
              "date": "2001-08-09",
              "value": "96 mm[Hg]"
            },
            {
              "date": "2002-08-15",
              "value": "85 mm[Hg]"
            },
            {
              "date": "2003-08-21",
              "value": "88 mm[Hg]"
            },
            {
              "date": "2004-08-26",
              "value": "83 mm[Hg]"
            },
            {
              "date": "2005-09-01",
              "value": "84 mm[Hg]"
            },
            {
              "date": "2006-09-07",
              "value": "84 mm[Hg]"
            },
            {
              "date": "2007-03-29",
              "value": "86 mm[Hg]"
            },
            {
              "date": "2007-09-13",
              "value": "93 mm[Hg]"
            },
            {
              "date": "2008-09-18",
              "value": "88 mm[Hg]"
            },
            {
              "date": "2009-09-24",
              "value": "85 mm[Hg]"
            },
            {
              "date": "2010-09-30",
              "value": "86 mm[Hg]"
            },
            {
              "date": "2011-10-06",
              "value": "87 mm[Hg]"
            },
            {
              "date": "2012-03-15",
              "value": "82 mm[Hg]"
            },
            {
              "date": "2012-10-11",
              "value": "83 mm[Hg]"
            },
            {
              "date": "2013-10-17",
              "value": "101 mm[Hg]"
            },
            {
              "date": "2014-10-23",
              "value": "109 mm[Hg]"
            },
            {
              "date": "2014-11-22",
              "value": "80 mm[Hg]"
            },
            {
              "date": "2015-01-21",
              "value": "68 mm[Hg]"
            },
            {
              "date": "2015-03-22",
              "value": "72 mm[Hg]"
            },
            {
              "date": "2015-10-29",
              "value": "67 mm[Hg]"
            },
            {
              "date": "2016-11-03",
              "value": "76 mm[Hg]"
            },
            {
              "date": "2017-11-09",
              "value": "75 mm[Hg]"
            },
            {
              "date": "2018-09-06",
              "value": "71 mm[Hg]"
            },
            {
              "date": "2018-11-15",
              "value": "71 mm[Hg]"
            },
            {
              "date": "2019-01-24",
              "value": "69 mm[Hg]"
            },
            {
              "date": "2019-04-25",
              "value": "68 mm[Hg]"
            },
            {
              "date": "2019-11-21",
              "value": "74 mm[Hg]"
            },
            {
              "date": "2020-11-26",
              "value": "58 mm[Hg]"
            },
            {
              "date": "2021-08-05",
              "value": "68 mm[Hg]"
            },
            {
              "date": "2021-12-02",
              "value": "62 mm[Hg]"
            },
            {
              "date": "2022-01-06",
              "value": "68 mm[Hg]"
            },
            {
              "date": "2022-02-03",
              "value": "60 mm[Hg]"
            },
            {
              "date": "2022-03-03",
              "value": "62 mm[Hg]"
            },
            {
              "date": "2022-05-05",
              "value": "62 mm[Hg]"
            },
            {
              "date": "2022-06-02",
              "value": "67 mm[Hg]"
            },
            {
              "date": "2022-08-04",
              "value": "60 mm[Hg]"
            },
            {
              "date": "2022-11-03",
              "value": "59 mm[Hg]"
            },
            {
              "date": "2022-12-08",
              "value": "65 mm[Hg]"
            },
            {
              "date": "2023-02-02",
              "value": "64 mm[Hg]"
            },
            {
              "date": "2023-03-02",
              "value": "59 mm[Hg]"
            },
            {
              "date": "2023-08-31",
              "value": "73 mm[Hg]"
            },
            {
              "date": "2023-09-28",
              "value": "58 mm[Hg]"
            },
            {
              "date": "2023-10-26",
              "value": "63 mm[Hg]"
            },
            {
              "date": "2023-12-14",
              "value": "58 mm[Hg]"
            },
            {
              "date": "2024-04-25",
              "value": "61 mm[Hg]"
            },
            {
              "date": "2024-06-20",
              "value": "64 mm[Hg]"
            },
            {
              "date": "2024-09-19",
              "value": "59 mm[Hg]"
            },
            {
              "date": "2024-11-21",
              "value": "61 mm[Hg]"
            },
            {
              "date": "2024-12-19",
              "value": "66 mm[Hg]"
            },
            {
              "date": "2025-03-20",
              "value": "59 mm[Hg]"
            },
            {
              "date": "2025-07-17",
              "value": "62 mm[Hg]"
            },
            {
              "date": "2025-08-14",
              "value": "59 mm[Hg]"
            },
            {
              "date": "2025-09-18",
              "value": "66 mm[Hg]"
            },
            {
              "date": "2025-12-25",
              "value": "65 mm[Hg]"
            },
            {
              "date": "2026-04-16",
              "value": "59 mm[Hg]"
            },
            {
              "date": "2026-05-14",
              "value": "59 mm[Hg]"
            },
            {
              "date": "2026-07-16",
              "value": "58 mm[Hg]"
            }
          ],
          "meta": {
            "block_type": "TABLE_BLOCK",
            "trend_value_sequence": true
          },
          "presentation": {
            "layout": "table",
            "density": "comfortable",
            "font_scale": "sm",
            "separators": true
          }
        }
      ],
      "presentation": {
        "density": "comfortable",
        "font_scale": "md",
        "layout": "mixed",
        "variant": "summary_narrative_card",
        "tone": "clinical",
        "emphasis": "data-first",
        "body_markdown_visible": true,
        "theme": "clinical_dark"
      },
      "meta": {
        "render_hint": "labs",
        "summary_narrative_card": true,
        "structured_body_authoritative": true,
        "body_markdown_visible": true,
        "trend_interpretation_card": true,
        "trend_candidate_blocks": true,
        "protocol_version": "structured-output-v2",
        "adk_clinical_facts_panel": true,
        "adk_facts_panel_title": "Facts & Evidences",
        "adk_trend_viz_targets": [
          {
            "item_id": "vital:8462-4@mm[Hg]",
            "label": "Diastolic Blood Pressure",
            "code": "8462-4",
            "unit": "mm[Hg]"
          }
        ]
      }
    }
  },
  {
    "id": "conditions",
    "question": "/conditions",
    "answer": "There are 24 conditions recorded in the chart.\n- Medication review due, active, onset 2026-05-14\n- Stress, active, onset 2025-12-25\n- Aortic valve stenosis, active, onset 2023-06-22\nThe full list is in the Facts & Evidences card below.",
    "intent_type": "data_query",
    "tools_used": [
      "get_conditions"
    ],
    "processing_time_ms": 1185,
    "thinking_event_count": 17,
    "suggestions": [
      "What is the current eGFR and albuminuria status for her CKD and diabetic kidney disease?",
      "How has her aortic valve stenosis progressed on recent echocardiography?",
      "Given her ischemic heart disease, are the simvastatin and clopidogrel orders still active?"
    ],
    "structured": {
      "response_type": "table",
      "title": "List of active conditions",
      "sections": [
        {
          "type": "table",
          "columns": [
            "Condition",
            "Status",
            "Code (SNOMED)",
            "Onset Date"
          ],
          "rows": [
            {
              "condition": "Medication review due",
              "status": "active",
              "code (snomed)": "314529007",
              "onset date": "2026-05-14"
            },
            {
              "condition": "Stress",
              "status": "active",
              "code (snomed)": "73595000",
              "onset date": "2025-12-25"
            },
            {
              "condition": "Aortic valve stenosis",
              "status": "active",
              "code (snomed)": "60573004",
              "onset date": "2023-06-22"
            },
            {
              "condition": "Disorder of kidney due to diabetes mellitus",
              "status": "active",
              "code (snomed)": "127013003",
              "onset date": "2021-08-05"
            },
            {
              "condition": "Chronic kidney disease stage 1",
              "status": "active",
              "code (snomed)": "431855005",
              "onset date": "2021-08-05"
            },
            {
              "condition": "Abnormal findings diagnostic imaging heart+coronary circulat",
              "status": "active",
              "code (snomed)": "274531002",
              "onset date": "2019-12-03"
            },
            {
              "condition": "Ischemic heart disease",
              "status": "active",
              "code (snomed)": "414545008",
              "onset date": "2019-11-21"
            },
            {
              "condition": "Idiopathic atrophic hypothyroidism",
              "status": "active",
              "code (snomed)": "83664006",
              "onset date": "2015-08-24"
            },
            {
              "condition": "Hypertriglyceridemia",
              "status": "active",
              "code (snomed)": "302870006",
              "onset date": "2014-10-23"
            },
            {
              "condition": "Essential hypertension",
              "status": "active",
              "code (snomed)": "59621000",
              "onset date": "2014-10-23"
            },
            {
              "condition": "Metabolic syndrome X",
              "status": "active",
              "code (snomed)": "237602007",
              "onset date": "2013-10-17"
            },
            {
              "condition": "Diabetes mellitus type 2",
              "status": "active",
              "code (snomed)": "44054006",
              "onset date": "2013-10-17"
            },
            {
              "condition": "Refugee (person)",
              "status": "active",
              "code (snomed)": "446654005",
              "onset date": "2009-09-24"
            },
            {
              "condition": "Osteoporosis",
              "status": "active",
              "code (snomed)": "64859006",
              "onset date": "2006-09-07"
            },
            {
              "condition": "Dependent drug abuse",
              "status": "active",
              "code (snomed)": "6525002",
              "onset date": "2001-04-14"
            },
            {
              "condition": "Body mass index 30+ - obesity",
              "status": "active",
              "code (snomed)": "162864005",
              "onset date": "1992-07-30"
            },
            {
              "condition": "Impacted molars",
              "status": "active",
              "code (snomed)": "196416002",
              "onset date": "1991-05-05"
            },
            {
              "condition": "Chronic intractable migraine without aura",
              "status": "active",
              "code (snomed)": "124171000119105",
              "onset date": "1990-06-08"
            },
            {
              "condition": "Chronic pain",
              "status": "active",
              "code (snomed)": "82423001",
              "onset date": "1990-03-05"
            },
            {
              "condition": "Chronic sinusitis",
              "status": "active",
              "code (snomed)": "40055000",
              "onset date": "1990-02-27"
            },
            {
              "condition": "Loss of teeth",
              "status": "active",
              "code (snomed)": "37320007",
              "onset date": "1968-10-03"
            },
            {
              "condition": "Past pregnancy history of miscarriage",
              "status": "active",
              "code (snomed)": "161744009",
              "onset date": "1967-11-30"
            },
            {
              "condition": "Prediabetes",
              "status": "active",
              "code (snomed)": "714628002",
              "onset date": "1965-09-09"
            },
            {
              "condition": "Anemia",
              "status": "active",
              "code (snomed)": "271737000",
              "onset date": "1965-09-09"
            }
          ],
          "title": "Summary",
          "presentation": {
            "layout": "table",
            "density": "comfortable",
            "emphasis": "data-first",
            "font_scale": "md"
          },
          "meta": {
            "block_type": "TABLE_BLOCK"
          }
        }
      ],
      "meta": {
        "tool_name": "get_conditions",
        "render_hint": "conditions",
        "protocol_version": "structured-output-v2",
        "section_count": 1,
        "adk_clinical_facts_panel": true
      },
      "presentation": {
        "layout": "auto",
        "density": "comfortable",
        "emphasis": "default",
        "font_scale": "md"
      }
    }
  },
  {
    "id": "aortic-caregap",
    "question": "Are there any care gaps for this patient's Aortic valve stenosis?",
    "answer": "**Cardiovascular lead-specialty review**\n\nCare gaps exist regarding the assessment of aortic valve stenosis severity and left ventricular function. An echocardiogram is required to evaluate these parameters and to determine the specific etiology of the stenosis, such as calcific or bicuspid disease. Management must include obtaining these diagnostic studies to guide further clinical decision-making.",
    "intent_type": "clinical_reasoning",
    "tools_used": [
      "cma_route"
    ],
    "processing_time_ms": 16591,
    "thinking_event_count": 87,
    "suggestions": [
      "What were the specific findings and severity levels from the 2023-06-22 echocardiogram?",
      "Should we order a new echocardiogram to reassess valve severity and LV function?",
      "What else does the chart record about Active conditions?"
    ],
    "structured": {
      "response_type": "flexible",
      "title": "Cardiovascular lead-specialty review",
      "sections": [
        {
          "type": "list",
          "title": "Demographic & Physiologic Considerations",
          "items": [
            "Age: 80 years old; advanced age reduces renal function and increases risk for osteoporosis and cardiovascular events, contributing to her chronic kidney disease and aortic valve stenosis.",
            "Sex: Female; post-menopausal status increases cardiovascular risk, and age-related hormonal changes contribute to osteoporosis risk."
          ],
          "panel": "patient_summary"
        },
        {
          "type": "nested_list",
          "title": "Medical History",
          "items": [
            {
              "title": "Active conditions",
              "children": [
                "Abnormal findings diagnostic imaging heart+coronary circulat",
                "Anemia",
                "Aortic valve stenosis",
                "Body mass index 30+ - obesity",
                "Chronic intractable migraine without aura",
                "Chronic kidney disease stage 1",
                "Chronic pain",
                "Chronic sinusitis",
                "Dependent drug abuse",
                "Diabetes mellitus type 2",
                "Disorder of kidney due to diabetes mellitus",
                "Essential hypertension",
                "Hypertriglyceridemia",
                "Idiopathic atrophic hypothyroidism",
                "Impacted molars",
                "Ischemic heart disease",
                "Loss of teeth",
                "Metabolic syndrome X",
                "Osteoporosis",
                "Prediabetes",
                "Past pregnancy history of miscarriage"
              ],
              "count": 21,
              "columns": 2
            },
            {
              "title": "Past medical history",
              "children": [
                "Gingivitis (resolved 2024-10-03, onset 2024-09-19)",
                "Medication review due (resolved 2024-04-25, onset 2024-04-25)",
                "Polyp of colon (resolved 2019-12-12, onset 2017-10-15)",
                "Recurrent rectal polyp (resolved 2019-12-12, onset 2018-11-25)",
                "Streptococcal sore throat (resolved 2019-04-27, onset 2019-04-16)",
                "Fractured dental filling (resolved 2018-11-29, onset 2018-11-29)",
                "Overdose (resolved 2010-02-12, onset 2010-02-12)",
                "Viral sinusitis (resolved 1999-02-04, onset 1999-01-14)",
                "Sinusitis (resolved 1992-08-11, onset 1992-07-04)",
                "Acute viral pharyngitis (resolved 1984-03-15, onset 1984-03-06)",
                "Sprain of ankle (resolved 1983-06-01, onset 1983-05-05)",
                "Sprain (resolved 1983-06-01, onset 1983-05-05)",
                "Gingival disease (resolved 1980-10-09, onset 1980-10-09)",
                "Normal pregnancy (resolved 1976-10-10, onset 1976-09-23)",
                "Miscarriage in first trimester (resolved 1967-11-30, onset 1967-11-16)",
                "Complete miscarriage (resolved 1967-11-30, onset 1967-11-16)",
                "Acute infective cystitis (resolved 1963-06-05, onset 1963-06-03)",
                "Primary dental caries (resolved 1962-09-06, onset 1962-09-06)",
                "Acute bronchitis (resolved 1953-03-30, onset 1953-03-16)",
                "Laceration - injury (resolved 1951-08-03, onset 1951-07-17)",
                "Laceration of thigh (resolved 1951-08-03, onset 1951-07-17)",
                "Otitis media (resolved 1951-06-21, onset 1951-04-16)",
                "Alveolitis of jaw (resolved 1950-06-27, onset 1950-06-27)",
                "Infection of tooth (resolved 1950-06-22, onset 1950-06-22)"
              ],
              "count": 24,
              "columns": 2
            },
            {
              "title": "Family history: none recorded",
              "children": []
            },
            {
              "title": "Allergies: none recorded",
              "children": []
            },
            {
              "title": "Trends (past 2 years)",
              "children": [
                "Bilirubin.total in Urine increased",
                "Calcium increased",
                "Carbon dioxide, total increased",
                "Chloride decreased",
                "Cholesterol decreased",
                "Cholesterol in HDL decreased",
                "Cholesterol in LDL increased",
                "Creatinine [Mass/volume] in Blood increased",
                "Creatinine [Mass/volume] in Serum or Plasma decreased",
                "Fall risk total decreased",
                "Generalized anxiety disorder 7 item (GAD-7) total score decreased",
                "Glomerular filtration rate increased",
                "Glucose decreased",
                "Glucose in Urine decreased",
                "Heart rate increased",
                "Hemoglobin A1c/Hemoglobin.total unchanged",
                "Ketones in Urine increased",
                "Microalbumin/Creatinine in Urine decreased",
                "Pain severity - 0-10 verbal numeric rating - Reported decreased",
                "Patient Health Questionnaire 2 item (PHQ-2) total score increased",
                "Potassium decreased",
                "Protein in Urine increased",
                "Respiratory rate increased",
                "Sodium increased",
                "Specific gravity of Urine increased",
                "Triglyceride decreased",
                "Urea nitrogen decreased",
                "pH of Urine increased"
              ],
              "count": 28,
              "columns": 2,
              "childGlyphs": [
                "increased",
                "increased",
                "increased",
                "decreased",
                "decreased",
                "decreased",
                "increased",
                "increased",
                "decreased",
                "decreased",
                "decreased",
                "increased",
                "decreased",
                "decreased",
                "increased",
                "unchanged",
                "increased",
                "decreased",
                "decreased",
                "increased",
                "decreased",
                "increased",
                "increased",
                "increased",
                "increased",
                "decreased",
                "decreased",
                "increased"
              ]
            },
            {
              "title": "Current medications",
              "children": [
                "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder))",
                "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder))",
                "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder))",
                "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder))",
                "Alendronic acid 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Osteoporosis (disorder))",
                "Simvastatin 20 MG Oral Tablet (active, 2019-11-28 03:01:56)",
                "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56)",
                "Clopidogrel 75 MG Oral Tablet (active, 2019-11-28 03:01:56)",
                "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56)",
                "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56)"
              ],
              "count": 10,
              "columns": 2
            }
          ],
          "panel": "patient_summary"
        },
        {
          "type": "list",
          "title": "Organ Health",
          "items": [
            "Heart: function severe, risk level moderate; assessment rests on thin or dated evidence, raised by LDL 100-159, former smoking, and overweight body habitus, lowered by blood pressure <120/80, normal glucose, and within-limits alcohol use; weekly physical activity and diet quality not on record."
          ],
          "panel": "patient_summary",
          "itemGlyphs": [
            "critical"
          ]
        },
        {
          "type": "nested_list",
          "title": "Social Determinants of Health (SDOH)",
          "items": [
            {
              "title": "",
              "children": [
                "Housing: barrier — Refugee -- limits access to stable living conditions and potentially healthcare resources.; screening stale",
                "Social support: barrier — Social isolation -- increases risk for poor health outcomes and reduced adherence to care plans.; screening stale",
                "Interpersonal safety: barrier; screening stale",
                "Psychological stress: barrier — Stress -- negatively impacts health through physiological and behavioral pathways, potentially worsening chronic conditions.; screening stale",
                "Justice involvement: barrier — Has a criminal record -- may create barriers to employment, housing, and healthcare access.",
                "Employment: screened negative — Full-time employment -- provides financial stability and social connection.",
                "Education: screened negative — Educated to high school level -- associated with better health literacy and outcomes.; screening stale"
              ],
              "childGlyphs": [
                "barrier",
                "barrier",
                "barrier",
                "barrier",
                "barrier",
                "screened_negative",
                "screened_negative"
              ]
            }
          ],
          "panel": "patient_summary"
        },
        {
          "type": "list",
          "title": "Care Gaps",
          "items": [
            "Echocardiogram to assess aortic valve stenosis severity and LV function",
            "Review of specific aortic valve stenosis etiology (e.g., calcific, bicuspid)",
            "Specific aortic valve stenosis findings from 2023-06-22 echocardiogram",
            "Current symptoms related to aortic valve stenosis",
            "Physical examination findings related to aortic valve stenosis (murmur characteristics)"
          ]
        }
      ],
      "presentation": {
        "density": "comfortable",
        "tone": "clinical"
      },
      "meta": {
        "render_hint": "cma",
        "response_shape": "focused",
        "protocol_version": "structured-output-v2",
        "section_count": 5,
        "preserve_section_titles": true,
        "tools_used": [
          "cma_route"
        ],
        "adk_clinical_facts_panel": true,
        "adk_facts_panel_title": "Facts & Evidences",
        "adk_patient_summary_panel_title": "Patient Summary"
      }
    },
    "guideline_evidence": {
      "categories": [
        {
          "category": "care_gaps",
          "answer": "",
          "evidence_quality": "strong",
          "source_numbers": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7"
          ]
        }
      ],
      "references": [
        {
          "doc_title": "2020 ACC-AHA Guideline for the Management of Patients With Valvular Heart Disease (2020)",
          "document_type": "guideline",
          "passages": [
            {
              "category": "care_gaps",
              "number": "2",
              "snippet": "likely to beneﬁt from a drug, device, or treatment strategy, and to what degree. Criteria for commissioning an evidence review committee and formal systematic review include absence of a current authoritative systematic review, feasibility of deﬁning the beneﬁt and risk in a time",
              "passage_text": "likely to beneﬁt from a drug, device, or treatment strategy, and to what degree. Criteria for commissioning an evidence review committee and formal systematic review include absence of a current authoritative systematic review, feasibility of deﬁning the beneﬁt and risk in a time frame consistent with the writing of a guideline, relevance to a substantial number of patients, and likelihood that the ﬁndings can be translated into actionable recommendations. Evidence review committee members may include methodologists, epidemiologists, clinicians, and biostatisticians. Recommendations developed by the writing committee on the basis of the systematic review are marked “SR.” Guideline-Directed Management and Therapy The term guideline-directed management and therapy (GDMT) encompasses clinical evaluation, diagnostic testing, and both pharmacological and procedural treatments. For these and all recommended drug treatment regimens, the reader should conﬁrm dosage with product insert material and evaluate for contraindications and interactions. Recommendations are limited to drugs, devices, and treatments approved for clinical use in the United States. Patrick T. O’Gara, MD, MACC, FAHA, C",
              "document_type": "guideline",
              "section": "2020 ACC-AHA Guideline for the Management of Patients With Valvular Heart Disease (2020) > p. 6",
              "page_start": 6,
              "page_end": 6
            },
            {
              "category": "care_gaps",
              "number": "7",
              "snippet": "annular–to–coronary ostial distance. 3.2.1.2. Diagnostic Testing: Changing Signs or Symptoms In patients with known valvular AS, repeat TTE is prudent when physical examination shows an increase in the loudness of the murmur, the murmur peaks later in systole, the A2 component of",
              "passage_text": "annular–to–coronary ostial distance. 3.2.1.2. Diagnostic Testing: Changing Signs or Symptoms In patients with known valvular AS, repeat TTE is prudent when physical examination shows an increase in the loudness of the murmur, the murmur peaks later in systole, the A2 component of the second heart sound is diminished or absent, or symptoms occur that might be attributable to AS. Repeat TTE is also appropriate in patients with AS who are exposed to increased hemodynamic demands, either electively, such as with noncardiac surgery or pregnancy, or acutely, such as with a systemic infection, anemia, or gastrointestinal bleeding. In these clinical settings, knowledge of the severity of valve obstruction and LV function is critical for optimizing loading conditions and maintaining a normal cardiac output. 3.2.1.3. Diagnostic Testing: Routine Follow-Up Timing of periodic clinical evaluation of asymptomatic patients with severe AS depends on comorbidities and patient-speciﬁc factors, as well as AS severity (Table 4). When severe AS is present (aortic velocity $4.0 m/s), the rate of progression to symptoms is high, with an eventfree survival rate of only 30% to 50% at 2 years. In patients wi",
              "document_type": "guideline",
              "section": "2020 ACC-AHA Guideline for the Management of Patients With Valvular Heart Disease (2020) > p. 24",
              "page_start": 24,
              "page_end": 24
            }
          ]
        },
        {
          "doc_title": "Textbook of Clinical Echocardiography (2024)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "care_gaps",
              "number": "1",
              "snippet": "The specific cause of aortic stenosis has significant implications in terms of patient outcomes and treatment options. Calcific Aortic Stenosis About 25% of all adults older than 65 years of age have aortic valve “sclerosis”—focal areas of increased echogenicity, typically at the",
              "passage_text": "The specific cause of aortic stenosis has significant implications in terms of patient outcomes and treatment options. Calcific Aortic Stenosis About 25% of all adults older than 65 years of age have aortic valve “sclerosis”—focal areas of increased echogenicity, typically at the base of the valve leaflets, without significant obstruction to LV outflow. About 10% to 15% of these patients have progressive leaflet thickening over several years that results in significant obstruction to LV outflow and typically manifests at 70 to 85 years of age. The presence of aortic sclerosis, even without valve obstruction, is a marker of atherosclerosis and is associated with an increased risk of adverse cardiovascular events. When obstruction is present, imaging shows a marked increase in echogenicity of the leaflets, consistent with calcific disease and reduced systolic opening. The degree of valve calcification is a strong predictor of clinical outcome, either graded qualitatively on echocardiography as mild, moderate, or severe or, more precisely, by quantitative computed tomographic calcium scoring.",
              "document_type": "textbook",
              "section": "Textbook of Clinical Echocardiography (2024) > p. 330",
              "page_start": 330,
              "page_end": 330
            },
            {
              "category": "care_gaps",
              "number": "3",
              "snippet": "Aortic Stenosis With Left Ventricular Systolic Dysfunction When aortic velocity is less than 4.0 m/s but valve area is less than 1.0 cm2, the possibility of “low-­flow, low-­ gradient” aortic stenosis must be considered. When LV systolic dysfunction is present (ejection fraction ",
              "passage_text": "Aortic Stenosis With Left Ventricular Systolic Dysfunction When aortic velocity is less than 4.0 m/s but valve area is less than 1.0 cm2, the possibility of “low-­flow, low-­ gradient” aortic stenosis must be considered. When LV systolic dysfunction is present (ejection fraction < 50%), aortic valve opening may be reduced as a result of the low flow rate across the valve with only mild or moderate valve disease. For example, with an LV assist device, the aortic valve opens very little because little flow occurs across the valve. Conversely, severe valve stenosis may be present with a low gradient as a result of the low-­ volume flow rate. The diagnostic problem is distinguishing stiff leaflets that cannot open from relatively normal leaflets that could open if volume flow rate was normal. In a patient with low-­flow, low-­gradient aortic stenosis with LV systolic dysfunction, the first steps are to evaluate for other causes of LV dysfunction, assess aortic valve anatomy (e.g., a bicuspid valve) and leaflet calcification,",
              "document_type": "textbook",
              "section": "Textbook of Clinical Echocardiography (2024) > p. 344",
              "page_start": 344,
              "page_end": 344
            }
          ]
        },
        {
          "doc_title": "Critical Care Medicine - Principles of Diagnosis and Management in the Adult, 5th Edition (2019)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "care_gaps",
              "number": "4",
              "snippet": "aortic valve disease is part of a larger aortopathy8 syndrome with significant implications for the natural course of aortic valve disease.9 The most common acquired anomaly is typically referred to as degenerative disease, an atherosclerotic process that represents a continuum f",
              "passage_text": "aortic valve disease is part of a larger aortopathy8 syndrome with significant implications for the natural course of aortic valve disease.9 The most common acquired anomaly is typically referred to as degenerative disease, an atherosclerotic process that represents a continuum from aortic valve sclerosis, which is not associated with a hemodynamically significant gradient, to a densely calcified aortic 470 Stages of Progression of Valvular Heart Disease TABLE 30.1 Stage Definition Description A At risk Patients with risk factors for the development of VHD B Progressive Patients with progressive VHD (mild to moderate severity and asymptomatic) C Asymptomatic severe Asymptomatic patients who reached the criteria for severe VHD C1: Asymptomatic patients with severe VHD in whom the left or right ventricle remains compensated C2: Asymptomatic patients who have severe VHD with decompensation of the left or right ventricle D Symptomatic severe Patients who have developed symptoms as a result of VHD VHD, Valvular heart disease. From 2014 AHA/ACC Guideline for the Management of Patients With Valvular Heart Disease: executive summary: a report of the American College of Cardiology/ American",
              "document_type": "textbook",
              "section": "Critical Care Medicine - Principles of Diagnosis and Management in the Adult, 5th Edition (2019) > pp. 639-640",
              "page_start": 639,
              "page_end": 640
            }
          ]
        },
        {
          "doc_title": "Mills and Sternberg's Diagnostic Surgical Pathology, 7th Edition (2022)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "care_gaps",
              "number": "5",
              "snippet": "Senile Calcific Trileaflet Aortic Stenosis Like BAV, calcification and other fibrodegenerative changes occur in the valve cusps of an otherwise normal valve. It presents in an older age group than BAV and is not associated with aortic dilatation. Calcifications are arranged as no",
              "passage_text": "Senile Calcific Trileaflet Aortic Stenosis Like BAV, calcification and other fibrodegenerative changes occur in the valve cusps of an otherwise normal valve. It presents in an older age group than BAV and is not associated with aortic dilatation. Calcifications are arranged as nodular protrusions into the sinuses and are distributed in all three leaflets (Fig. 29.52). The orifice is triangular in shape, and the leaflets are thickened, but the free edge of the leaflet is only minimally thickened. Current molecular insights suggest that this pattern is more complex than simply a “wear-andtear” process. The calcification and remodeling of the valve matrix is an active cellular process with interactions of multiple cell signaling pathways. FIGURE 29.52 Senile calcific tricuspid aortic stenosis. The three leaflets display normal commissures and slight thickening along the valve edge. Large collections of calcific deposits protrude into the sinuses of all three leaflets. Postinflammatory/Postrheumatic Aortic Stenosis",
              "document_type": "textbook",
              "section": "Mills and Sternberg's Diagnostic Surgical Pathology, 7th Edition (2022) > pp. 3636-3637",
              "page_start": 3636,
              "page_end": 3637
            }
          ]
        },
        {
          "doc_title": "Braunwald's Heart Disease - A Textbook of Cardiovascular Medicine, 2-Volume Set, 12th Edition (2021)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "care_gaps",
              "number": "6",
              "snippet": "DISEASES OF THE HEART VALVES CAUSE (%) CAUSE (%) 40 60 26.8 40 Surgical TAVI 20 24.2 20 Transcatheter 0 0 0 0 6 12 18 24 6 12 18 24 MONTHS MONTHS No. at Risk TAVI Standard Therapy No. at Risk Transcatheter Surgical 179 138 121 122 83 67 41 26 12 179 348 351 298 252 260 236 147 13",
              "passage_text": "DISEASES OF THE HEART VALVES CAUSE (%) CAUSE (%) 40 60 26.8 40 Surgical TAVI 20 24.2 20 Transcatheter 0 0 0 0 6 12 18 24 6 12 18 24 MONTHS MONTHS No. at Risk TAVI Standard Therapy No. at Risk Transcatheter Surgical 179 138 121 122 83 67 41 26 12 179 348 351 298 252 260 236 147 139 67 65 A B 100 30 P=0.04 for superiority DEATH FROM ANY CAUSE (%) 90 25 Surgical replacement 19.1 80 20 15 70 14.2 10 60 TAVR 5 50 0 10 8 6 40 4 2 0 12 30 20 10 0 0 8 10 12 2 4 6 MONTHS No. at Risk TAVR Surgical Replacement 390 357 377 341 353 297 329 274 C FIGURE 74.1 TAVR versus surgery randomized trials in extreme and high- risk patients; primary endpoint, all- cause death at 1 year. A, Extreme- risk patients with balloonexpandable TAVR. B, High- risk patients with balloon- expandable TAVR. C, High- risk patients with self- expanding TAVR. (From Transcatheter aortic- valve implantation for aortic stenosis in patients who cannot undergo surgery. N Engl J Med; Transcatheter versus surgical aortic- valve replacement in high- risk patients. N Engl J Med; Transcatheter aortic- valve replacement with a self- expanding prosthesis. N Engl J Med ) (eFig. 74.5A). In most studies, moderate or severe (but not mild)",
              "document_type": "textbook",
              "section": "Braunwald's Heart Disease - A Textbook of Cardiovascular Medicine, 2-Volume Set, 12th Edition (2021) > p. 1966",
              "page_start": 1966,
              "page_end": 1966
            }
          ]
        }
      ],
      "review_incomplete": false,
      "retrieval_quality": {},
      "uncited_retrieval_disclosure": "5 guideline source(s) were retrieved for this review. The reasoning above does not cite any of them directly, so treat these as background reading rather than as the stated basis for the conclusions above."
    }
  },
  {
    "id": "medications",
    "question": "Are there any concerns with this patient's current medications?",
    "answer": "**Pharmacology lead-specialty review**\n\nYes, there are concerns with this patient's current medications.\n**Label findings**\n- Hypotension risk: [Lisinopril](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=314076) and [hydrochlorothiazide](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=310798) together may cause excessive blood pressure reduction; consider decreasing or discontinuing the diuretic, increasing salt intake, or reducing the starting dose of [lisinopril](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=314076).\n- Myopathy risk: The combination of [simvastatin](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=312961) and [amlodipine](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=308136) increases the risk of myopathy and rhabdomyolysis; limit the [simvastatin](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=312961) dose to 20 mg daily.\n- Hypoglycemia risk: [Lisinopril](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=314076) and insulin may increase the risk of hypoglycemia; monitor glycemic control closely, especially during the first month of [lisinopril](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=314076) treatment.\n- Hypotension risk: [Nitroglycerin](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=705129) and [amlodipine](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=308136) together may cause marked symptomatic orthostatic hypotension; observe for additive hypotensive effects and consider dose adjustments.\n- Hypotension risk: [Nitroglycerin](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=705129) and metoprolol succinate together may cause increased hypotensive effects; observe for additive effects.\n- Hypoglycemia risk: [Levothyroxine sodium](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=966222) may worsen glycemic control and increase insulin requirements; monitor diabetic control closely, especially when thyroid therapy is started, changed, or discontinued.\n- Hypotension risk: [Lisinopril](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=314076) and [hydrochlorothiazide](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=310798) together may cause potentiation of orthostatic hypotension; monitor closely.\n- Hypotension risk: [Lisinopril](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=314076) and [hydrochlorothiazide](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=310798) together may cause excessive reduction of blood pressure; monitor closely.\n- Hypotension risk: [Nitroglycerin](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=705129) and [amlodipine](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=308136) together may cause marked symptomatic orthostatic hypotension; monitor closely.\n- Hypotension risk: [Nitroglycerin](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=705129) and [amlodipine](https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=308136) together may cause increased hypotensive effects; monitor closely.\n**Evidence review**\n- The patient's advanced age (80 years) increases the risk of adverse effects from medications, particularly hypotension and polypharmacy [6].\n- The patient has multiple chronic conditions, including heart failure (NYHA Class III, NT-proBNP 2400 pg/mL on 2026-07-16), chronic kidney disease (eGFR 6.0382 mL/min on 2026-05-14), and diabetes mellitus type 2, which increase the risk of drug interactions and adverse effects [4, 2, 1, 13].\n- The patient has documented social determinants of health barriers, including housing instability (refugee status), social isolation, interpersonal safety concerns, psychological stress, and justice involvement, which may impact medication adherence and outcomes [3, 5, 8, 11, 12, 7, 9, 10].\nThe panel below carries the full label record (123 findings).",
    "intent_type": "clinical_reasoning",
    "tools_used": [
      "cma_route"
    ],
    "processing_time_ms": 158848,
    "thinking_event_count": 60,
    "suggestions": [
      "Are the orders for simvastatin, nitroglycerin, and clopidogrel still active?",
      "Should we re-evaluate the necessity of metoprolol succinate given the 2019 order date?",
      "Given the increased creatinine and proteinuria, should we adjust the lisinopril dose?"
    ],
    "structured": {
      "response_type": "flexible",
      "title": "Pharmacology lead-specialty review",
      "sections": [
        {
          "type": "list",
          "title": "Demographic & Physiologic Considerations",
          "items": [
            "Age: 80 years old; advanced age reduces renal function and increases risk for osteoporosis and cardiovascular events, contributing to her chronic kidney disease and aortic valve stenosis.",
            "Sex: Female; post-menopausal status increases cardiovascular risk, and age-related hormonal changes contribute to osteoporosis risk."
          ],
          "panel": "patient_summary"
        },
        {
          "type": "nested_list",
          "title": "Medical History",
          "items": [
            {
              "title": "Active conditions",
              "children": [
                "Abnormal findings diagnostic imaging heart+coronary circulat",
                "Anemia",
                "Aortic valve stenosis",
                "Body mass index 30+ - obesity",
                "Chronic intractable migraine without aura",
                "Chronic kidney disease stage 1",
                "Chronic pain",
                "Chronic sinusitis",
                "Dependent drug abuse",
                "Diabetes mellitus type 2",
                "Disorder of kidney due to diabetes mellitus",
                "Essential hypertension",
                "Hypertriglyceridemia",
                "Idiopathic atrophic hypothyroidism",
                "Impacted molars",
                "Ischemic heart disease",
                "Loss of teeth",
                "Metabolic syndrome X",
                "Osteoporosis",
                "Prediabetes",
                "Past pregnancy history of miscarriage"
              ],
              "count": 21,
              "columns": 2
            },
            {
              "title": "Past medical history",
              "children": [
                "Gingivitis (resolved 2024-10-03, onset 2024-09-19)",
                "Medication review due (resolved 2024-04-25, onset 2024-04-25)",
                "Polyp of colon (resolved 2019-12-12, onset 2017-10-15)",
                "Recurrent rectal polyp (resolved 2019-12-12, onset 2018-11-25)",
                "Streptococcal sore throat (resolved 2019-04-27, onset 2019-04-16)",
                "Fractured dental filling (resolved 2018-11-29, onset 2018-11-29)",
                "Overdose (resolved 2010-02-12, onset 2010-02-12)",
                "Viral sinusitis (resolved 1999-02-04, onset 1999-01-14)",
                "Sinusitis (resolved 1992-08-11, onset 1992-07-04)",
                "Acute viral pharyngitis (resolved 1984-03-15, onset 1984-03-06)",
                "Sprain of ankle (resolved 1983-06-01, onset 1983-05-05)",
                "Sprain (resolved 1983-06-01, onset 1983-05-05)",
                "Gingival disease (resolved 1980-10-09, onset 1980-10-09)",
                "Normal pregnancy (resolved 1976-10-10, onset 1976-09-23)",
                "Miscarriage in first trimester (resolved 1967-11-30, onset 1967-11-16)",
                "Complete miscarriage (resolved 1967-11-30, onset 1967-11-16)",
                "Acute infective cystitis (resolved 1963-06-05, onset 1963-06-03)",
                "Primary dental caries (resolved 1962-09-06, onset 1962-09-06)",
                "Acute bronchitis (resolved 1953-03-30, onset 1953-03-16)",
                "Laceration - injury (resolved 1951-08-03, onset 1951-07-17)",
                "Laceration of thigh (resolved 1951-08-03, onset 1951-07-17)",
                "Otitis media (resolved 1951-06-21, onset 1951-04-16)",
                "Alveolitis of jaw (resolved 1950-06-27, onset 1950-06-27)",
                "Infection of tooth (resolved 1950-06-22, onset 1950-06-22)"
              ],
              "count": 24,
              "columns": 2
            },
            {
              "title": "Family history: none recorded",
              "children": []
            },
            {
              "title": "Allergies: none recorded",
              "children": []
            },
            {
              "title": "Trends (past 2 years)",
              "children": [
                "Bilirubin.total in Urine increased",
                "Calcium increased",
                "Carbon dioxide, total increased",
                "Chloride decreased",
                "Cholesterol decreased",
                "Cholesterol in HDL decreased",
                "Cholesterol in LDL increased",
                "Creatinine [Mass/volume] in Blood increased",
                "Creatinine [Mass/volume] in Serum or Plasma decreased",
                "Fall risk total decreased",
                "Generalized anxiety disorder 7 item (GAD-7) total score decreased",
                "Glomerular filtration rate increased",
                "Glucose decreased",
                "Glucose in Urine decreased",
                "Heart rate increased",
                "Hemoglobin A1c/Hemoglobin.total unchanged",
                "Ketones in Urine increased",
                "Microalbumin/Creatinine in Urine decreased",
                "Pain severity - 0-10 verbal numeric rating - Reported decreased",
                "Patient Health Questionnaire 2 item (PHQ-2) total score increased",
                "Potassium decreased",
                "Protein in Urine increased",
                "Respiratory rate increased",
                "Sodium increased",
                "Specific gravity of Urine increased",
                "Triglyceride decreased",
                "Urea nitrogen decreased",
                "pH of Urine increased"
              ],
              "count": 28,
              "columns": 2,
              "childGlyphs": [
                "increased",
                "increased",
                "increased",
                "decreased",
                "decreased",
                "decreased",
                "increased",
                "increased",
                "decreased",
                "decreased",
                "decreased",
                "increased",
                "decreased",
                "decreased",
                "increased",
                "unchanged",
                "increased",
                "decreased",
                "decreased",
                "increased",
                "decreased",
                "increased",
                "increased",
                "increased",
                "increased",
                "decreased",
                "decreased",
                "increased"
              ]
            },
            {
              "title": "Current medications",
              "children": [
                "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder))",
                "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder))",
                "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder))",
                "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder))",
                "Alendronic acid 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Osteoporosis (disorder))",
                "Simvastatin 20 MG Oral Tablet (active, 2019-11-28 03:01:56)",
                "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56)",
                "Clopidogrel 75 MG Oral Tablet (active, 2019-11-28 03:01:56)",
                "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56)",
                "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56)"
              ],
              "count": 10,
              "columns": 2
            }
          ],
          "panel": "patient_summary"
        },
        {
          "type": "list",
          "title": "Organ Health",
          "items": [
            "Heart: function severe, risk level moderate; assessment rests on thin or dated evidence, raised by LDL 100-159, former smoking, and overweight body habitus, lowered by blood pressure <120/80, normal glucose, and within-limits alcohol use; weekly physical activity and diet quality not on record."
          ],
          "panel": "patient_summary",
          "itemGlyphs": [
            "critical"
          ]
        },
        {
          "type": "nested_list",
          "title": "Social Determinants of Health (SDOH)",
          "items": [
            {
              "title": "",
              "children": [
                "Housing: barrier — Refugee -- limits access to stable living conditions and potentially healthcare resources.; screening stale",
                "Social support: barrier — Social isolation -- increases risk for poor health outcomes and reduced adherence to care plans.; screening stale",
                "Interpersonal safety: barrier; screening stale",
                "Psychological stress: barrier — Stress -- negatively impacts health through physiological and behavioral pathways, potentially worsening chronic conditions.; screening stale",
                "Justice involvement: barrier — Has a criminal record -- may create barriers to employment, housing, and healthcare access.",
                "Employment: screened negative — Full-time employment -- provides financial stability and social connection.",
                "Education: screened negative — Educated to high school level -- associated with better health literacy and outcomes.; screening stale"
              ],
              "childGlyphs": [
                "barrier",
                "barrier",
                "barrier",
                "barrier",
                "barrier",
                "screened_negative",
                "screened_negative"
              ]
            }
          ],
          "panel": "patient_summary"
        },
        {
          "type": "dailymed_panel",
          "title": "",
          "data": {
            "sections": [
              {
                "severity": "AVOID",
                "label": "Avoid",
                "items": []
              },
              {
                "severity": "MONITOR",
                "label": "Monitor",
                "items": [
                  {
                    "action": "The possibility of hypotensive effects with lisinopril can be minimized by either decreasing or ...",
                    "reasonings": [
                      "The possibility of hypotensive effects with lisinopril can be minimized by either decreasing or discontinuing the diuretic or increasing the salt intake prior to initiation of treatment with lisinopril, or reduce the starting dose of lisinopril tablets.",
                      "Initiation of lisinopril in patients on diuretics may result in excessive reduction of blood pressure.",
                      "Initiation of Lisinopril Tablets in patients on diuretics may result in excessive reduction of blood pressure."
                    ],
                    "pairs": [
                      {
                        "drug_a": "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:314076]",
                        "drug_b": "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:310798]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Monitor this combination.",
                    "reasonings": [
                      "No intervention is specified. In clinical trials, amlodipine has been safely administered with angiotensin-converting enzyme inhibitors.",
                      "No intervention is specified. In clinical trials, amlodipine has been safely administered with thiazide diuretics.",
                      "No intervention is specified. In clinical trials, amlodipine has been safely administered with beta-blockers.",
                      "Not specified. These agents have been associated with thyroid hormone and / or TSH level alterations by various mechanisms.",
                      "Not specified. In patients treated with large doses of propranolol (greater than 160 mg/day), T3 and T4 levels change, TSH levels remain normal, and patients are clinically euthyroid."
                    ],
                    "pairs": [
                      {
                        "drug_a": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]",
                        "drug_b": "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:314076]"
                      },
                      {
                        "drug_a": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]",
                        "drug_b": "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:310798]"
                      },
                      {
                        "drug_a": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]",
                        "drug_b": "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:866412]"
                      },
                      {
                        "drug_a": "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56) [RXNORM:966222]",
                        "drug_b": "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:314076]"
                      },
                      {
                        "drug_a": "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56) [RXNORM:966222]",
                        "drug_b": "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:310798]"
                      },
                      {
                        "drug_a": "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56) [RXNORM:966222]",
                        "drug_b": "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:866412]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Limit the dose of simvastatin in patients on amlodipine besylate to 20 mg daily.",
                    "reasonings": [
                      "Co-administration of multiple doses of 10 mg of amlodipine with 80 mg of simvastatin resulted in a 77% increase in exposure to simvastatin compared to simvastatin alone."
                    ],
                    "pairs": [
                      {
                        "drug_a": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]",
                        "drug_b": "Simvastatin 20 MG Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:312961]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Use this combination with caution.",
                    "reasonings": [
                      "Not specified. Potentiation of orthostatic hypotension may occur.",
                      "Not specified. The vasodilating effects of nitroglycerin may be additive with those of beta-blockers and may cause increased hypotensive effects.",
                      "Unspecified. In patients treated with large doses of propranolol (> 160 mg/day), T3 and T4 levels change, TSH levels remain normal, and patients are clinically euthyroid.",
                      "Not specified. Concomitant administration of Lisinopril Tablets and antidiabetic medicines (insulins, oral hypoglycemic agents) may cause an increased blood-glucose-lowering effect with risk of hypoglycemia.",
                      "Not specified. Additive effect or potentiation."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:310798]",
                        "drug_b": "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:314076]"
                      },
                      {
                        "drug_a": "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56) [RXNORM:705129]",
                        "drug_b": "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:866412]"
                      },
                      {
                        "drug_a": "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56) [RXNORM:966222]",
                        "drug_b": "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:866412]"
                      },
                      {
                        "drug_a": "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:314076]",
                        "drug_b": "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder)) [RXNORM:106892]"
                      },
                      {
                        "drug_a": "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:310798]",
                        "drug_b": "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder)) [RXNORM:106892]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "For patients taking verapamil, diltiazem, or dronedarone, do not exceed simvastatin 10 mg daily; ...",
                    "reasonings": [
                      "For patients taking verapamil, diltiazem, or dronedarone, do not exceed simvastatin 10 mg daily; for patients taking amiodarone, amlodipine, or ranolazine, do not exceed simvastatin 20 mg daily.",
                      "The risk of myopathy and rhabdomyolysis is increased by concomitant use of amiodarone, dronedarone, ranolazine, or calcium channel blockers with simvastatin."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Simvastatin 20 MG Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:312961]",
                        "drug_b": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "The risk of myopathy, including rhabdomyolysis, is increased by concomitant administration of amiodarone, dronedarone, ...",
                    "reasonings": [
                      "The risk of myopathy, including rhabdomyolysis, is increased by concomitant administration of amiodarone, dronedarone, ranolazine, or calcium channel blockers.",
                      "The risk of myopathy, including rhabdomyolysis, is increased by concomitant administration of amiodarone, dronedarone, ranolazine, or calcium channel blockers such as verapamil, diltiazem, or amlodipine."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Simvastatin 20 MG Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:312961]",
                        "drug_b": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Not explicitly stated, but listed under increased risk of myopathy/rhabdomyolysis.",
                    "reasonings": [
                      "The risk of myopathy, including rhabdomyolysis, is increased by concomitant administration of amiodarone, dronedarone, ranolazine, or calcium channel blockers such as verapamil, diltiazem, or amlodipine."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Simvastatin 20 MG Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:312961]",
                        "drug_b": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Patients receiving antihypertensive drugs, beta-adrenergic blockers, and nitrates should be observed for possible additive ...",
                    "reasonings": [
                      "Patients receiving antihypertensive drugs, beta-adrenergic blockers, and nitrates should be observed for possible additive hypotensive effects.",
                      "Marked orthostatic hypotension has been reported when calcium channel blockers and organic nitrates were used concomitantly.",
                      "Patients receiving antihypertensive drugs, beta-adrenergic blockers, or phenothiazines and nitrates should be observed for possible additive hypotensive effects."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56) [RXNORM:705129]",
                        "drug_b": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]"
                      },
                      {
                        "drug_a": "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56) [RXNORM:705129]",
                        "drug_b": "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:866412]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Dose adjustments of either class of agents may be necessary.",
                    "reasonings": [
                      "Marked symptomatic orthostatic hypotension has been reported when calcium channel blockers and organic nitrates were used in combination."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56) [RXNORM:705129]",
                        "drug_b": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Marked orthostatic hypotension has been reported when calcium channel blockers and organic nitrates were ...",
                    "reasonings": [
                      "Marked orthostatic hypotension has been reported when calcium channel blockers and organic nitrates were used concomitantly.",
                      "The vasodilating effects of nitroglycerin may be additive with those of calcium channel blockers and may cause increased hypotensive effects, and marked symptomatic orthostatic hypotension has been reported when used in combination."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56) [RXNORM:705129]",
                        "drug_b": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Not explicitly stated, but concomitant use with beta blockers can increase the risk of bradycardia.",
                    "reasonings": [
                      "Digitalis glycosides, clonidine, diltiazem, and verapamil slow atrioventricular conduction and decrease heart rate.",
                      "Digitalis glycosides, clonidine, diltiazem and verapamil slow atrioventricular conduction and decrease heart rate."
                    ],
                    "pairs": [
                      {
                        "drug_a": "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:866412]",
                        "drug_b": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "In diabetic patients treated with oral antidiabetic agents or insulin, glycemic control should be ...",
                    "reasonings": [
                      "In diabetic patients treated with oral antidiabetic agents or insulin, glycemic control should be closely monitored for hypoglycemia, especially during the first month of treatment with an ACE inhibitor.",
                      "Epidemiological studies have suggested that concomitant administration of ACE inhibitors and antidiabetic medicines (insulins, oral hypoglycemic agents) may cause an increased blood-glucose-lowering effect with risk of hypoglycemia."
                    ],
                    "pairs": [
                      {
                        "drug_a": "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:314076]",
                        "drug_b": "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder)) [RXNORM:106892]"
                      }
                    ],
                    "grade": "Monitor"
                  },
                  {
                    "action": "Careful monitoring of diabetic control is recommended, especially when thyroid therapy is started, changed, ...",
                    "reasonings": [
                      "Careful monitoring of diabetic control is recommended, especially when thyroid therapy is started, changed, or discontinued.",
                      "Addition of levothyroxine sodium capsules therapy in patients with diabetes mellitus may worsen glycemic control and result in increased antidiabetic agent or insulin requirements.",
                      "Addition of levothyroxine to antidiabetic or insulin therapy may result in increased antidiabetic agent or insulin requirements."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56) [RXNORM:966222]",
                        "drug_b": "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder)) [RXNORM:106892]"
                      }
                    ],
                    "grade": "Monitor"
                  }
                ]
              },
              {
                "severity": "ADJUST_DOSE",
                "label": "Adjust Dose",
                "items": [
                  {
                    "action": "Dosage adjustment of the antidiabetic drug may be required when coadministered with hydrochlorothiazide.",
                    "reasonings": [
                      "Dosage adjustment of the antidiabetic drug may be required when coadministered with hydrochlorothiazide."
                    ],
                    "pairs": [
                      {
                        "drug_a": "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:310798]",
                        "drug_b": "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder)) [RXNORM:106892]"
                      }
                    ],
                    "grade": "Adjust Dose"
                  }
                ]
              }
            ],
            "severe_effects": [
              {
                "drug": "lisinopril 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:314076]",
                "effects": [
                  {
                    "risk": "• When pregnancy is detected, discontinue lisinopril tablets as soon as possible",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Warning: fetal toxicity",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "When used in pregnancy during the second and third trimesters, ACE inhibitors can cause injury and even death to the developing fetus. When pregnancy is detected, lisinopril should be discontinued as soon as possible....",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Use in pregnancy",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "When pregnancy is detected, discontinue lisinopril as soon as possible [see WARNINGS AND PRECAUTIONS (5.1)]",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Use in pregnancywhen pregnancy is detected, lisinopril should be discontinued as soon as possible. See",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Contraindicated in history of angioedema or hypersensitivity related to previous treatment with an angiotensin converting enzyme inhibitor",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with aliskiren",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in hereditary or idiopathic angioedema",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in diabetes",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in patients who are hypersensitive to this product",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with neprilysin inhibitor (e.g., sacubitril)",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in hypersensitivity to this product",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with sacubitril/valsartan",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated: neprilysin inhibitor",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Angioedema, hypersensitivity, diabetes, and co-administration with aliskiren, neprilysin inhibitors, or sacubitril/valsartan are contraindicated."
              },
              {
                "drug": "amLODIPine 2.5 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:308136]",
                "effects": [
                  {
                    "risk": "Contraindicated in patients with known sensitivity to amlodipine besylate",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Amlodipine besylate sensitivity is contraindicated."
              },
              {
                "drug": "Hydrochlorothiazide 25 MG Oral Tablet (active, 2026-07-16 03:01:56, for Essential hypertension (disorder)) [RXNORM:310798]",
                "effects": [
                  {
                    "risk": "Contraindicated in Anuria",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated: sulfonamide-derived drugs",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Anuria and sulfonamide-derived drugs are contraindicated."
              },
              {
                "drug": "Alendronic acid 10 MG Oral Tablet (active, 2026-07-16 03:01:56, for Osteoporosis (disorder)) [RXNORM:904419]",
                "effects": [
                  {
                    "risk": "Contraindicated in Abnormalities of the esophagus which delay esophageal emptying such as stricture or achalasia",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Hypocalcemia",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Inability to stand or sit upright for at least 30 minutes",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated: Hypersensitivity to any component of this product",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Patients at increased risk of aspiration",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Hypocalcemia, esophageal abnormalities, inability to stand or sit upright, aspiration risk, and hypersensitivity are contraindicated."
              },
              {
                "drug": "Simvastatin 20 MG Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:312961]",
                "effects": [
                  {
                    "risk": "Contraindicated in Nursing mothers",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with gemfibrozil",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with danazol",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Women who are pregnant or may become pregnant",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with cyclosporine",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Acute liver failure or decompensated cirrhosis",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Active liver disease",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Hypersensitivity to simvastatin or any excipients in simvastatin tablets USP",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with strong CYP3A4 inhibitors (e.g., itraconazole, ketoconazole, posaconazole, voriconazole, HIV protease inhibitors, boceprevir, telaprevir, erythromycin, clarithromycin, telithromycin, nefazodone and cobicistat-containing products)",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Hypersensitivity to any component of this medication",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in unexplained persistent elevations of serum transaminases",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Pregnancy",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Hypersensitivity to simvastatin or any excipients in ZOCOR",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in lactation",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Active liver disease, acute liver failure, pregnancy, lactation, nursing, and hypersensitivity are contraindicated."
              },
              {
                "drug": "Nitroglycerin 0.4 MG/ACTUAT Mucosal Spray (active, 2019-11-28 03:01:56) [RXNORM:705129]",
                "effects": [
                  {
                    "risk": "Do not co-administer with tadalafil",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in severe anemia",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in hypersensitivity to nitroglycerin, other nitrates or nitrites or any excipient",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with avanafil",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with sildenafil",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in increased intracranial pressure",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated: PDE-5 inhibitors",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in shock",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with riociguat",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with vardenafil",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with selective inhibitor of cyclic guanosine monophosphate (cGMP)-specific phosphodiesterase type 5 (PDE5)",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with soluble guanylate cyclase (sGC) stimulators (such as riociguat)",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in cerebral hemorrhage or traumatic brain injury",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Circulatory Failure and Shock",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated: soluble guanylate cyclase (sGC) stimulators",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in patients who have shown hypersensitivity to it or to other nitrates or nitrites",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Do not co-administer with PDE-5-Inhibitors (such as avanafil, sildenafil, tadalafil, or vardenafil)",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Shock, circulatory failure, cerebral hemorrhage, traumatic brain injury, increased intracranial pressure, severe anemia, and PDE-5 inhibitors or sGC stimulators are contraindicated."
              },
              {
                "drug": "Clopidogrel 75 MG Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:309362]",
                "effects": [
                  {
                    "risk": "Diminished antiplatelet effect in patients with two loss-of-function alleles of the CYP2C19 gene",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Contraindicated in peptic ulcer",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in patients with hypersensitivity (e.g., anaphylaxis) to clopidogrel or any component of the product",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in intracranial hemorrhage",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Hypersensitivity to clopidogrel",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in hypersensitivity (e.g., anaphylaxis)",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Hypersensitivity to the drug substance or any component of the product",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Active pathological bleeding such as peptic ulcer or intracranial hemorrhage",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Intracranial hemorrhage, peptic ulcer, and hypersensitivity are contraindicated."
              },
              {
                "drug": "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet (active, 2019-11-28 03:01:56) [RXNORM:866412]",
                "effects": [
                  {
                    "risk": "Ischemic heart disease: Following abrupt cessation of therapy with certain beta-blocking agents, exacerbations of angina pectoris and, in some cases, myocardial infarction have occurred. When discontinuing chronically...",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Contraindicated in patients who are hypersensitive to any component of this product",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in second- or third- degree heart block",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in sick sinus syndrome",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in severe bradycardia",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in cardiogenic shock",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in decompensated heart failure",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in decompensated cardiac failure",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in heart block greater than first degree",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Hypersensitivity to metoprolol",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in Severe peripheral arterial circulatory disorders",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated: other beta-blockers",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in systolic blood pressure < 100 mmHg",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in sinus bradycardia",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in moderate-to-severe cardiac failure",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in heart rate < 45 beats/min",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in significant first-degree heart block (P-R interval ≥ 0.24 sec)",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in overt cardiac failure",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Cardiogenic shock, decompensated heart failure, second- or third-degree heart block, sick sinus syndrome, severe bradycardia, and hypersensitivity are contraindicated."
              },
              {
                "drug": "Levothyroxine Sodium 0.075 MG Oral Tablet (active, 2015-08-24 03:01:56) [RXNORM:966222]",
                "effects": [
                  {
                    "risk": "Not for treatment of obesity or for weight loss",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Thyroid hormones, including levothyroxine sodium, either alone or with other therapeutic agents, should not be used for the treatment of obesity or for weight loss. In euthyroid patients, doses within the range of daily...",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Warning",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Thyroid hormones, including LEVOTHROID",
                    "tier": "BOXED_WARNING"
                  },
                  {
                    "risk": "Contraindicated in uncorrected adrenal insufficiency",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in patients with hypersensitivity to any of the inactive ingredients in Levothyroxine Sodium Tablets, USP",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in acute myocardial infarction",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in untreated subclinical (suppressed serum TSH level with normal T3 and T4 levels) or overt thyrotoxicosis of any etiology",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in untreated subclinical thyrotoxicosis",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in patients with hypersensitivity to any of the inactive ingredients in SYNTHROID tablets",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in overt thyrotoxicosis of any etiology",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in patients with hypersensitivity to any of the inactive ingredients in LEVOTHROID® tablets",
                    "tier": "CONTRAINDICATION"
                  },
                  {
                    "risk": "Contraindicated in patients with hypersensitivity to any of the inactive ingredients in LEVOXYL tablets",
                    "tier": "CONTRAINDICATION"
                  }
                ],
                "contraindications_summary": "Uncorrected adrenal insufficiency, acute myocardial infarction, and untreated thyrotoxicosis are contraindicated."
              },
              {
                "drug": "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension [Humulin] (active, 2026-07-16 03:01:56, for Diabetes mellitus type 2 (disorder)) [RXNORM:106892]",
                "effects": [],
                "absence": "Resolved to RxNorm but has no label in the indexed prescription corpus (likely OTC-only); severe-effect tiers cannot be reported from this graph."
              }
            ],
            "corpus": "FDA DailyMed prescription drug labels (corpus snapshot full release 2026-08-14 (54,748 human-rx labels))"
          }
        }
      ],
      "presentation": {
        "density": "comfortable",
        "tone": "clinical"
      },
      "meta": {
        "render_hint": "cma",
        "response_shape": "safety_only",
        "protocol_version": "structured-output-v2",
        "section_count": 5,
        "preserve_section_titles": true,
        "tools_used": [
          "cma_route"
        ],
        "adk_clinical_facts_panel": true,
        "adk_facts_panel_title": "Facts & Evidences",
        "adk_patient_summary_panel_title": "Patient Summary"
      }
    },
    "rag_sources": [
      {
        "source": "The ESC Textbook of Heart Failure (2024) [p. 766]",
        "number": "3",
        "doc_title": "The ESC Textbook of Heart Failure (2024)",
        "chunk_id": "4c697668315fefac2f6d47b812bb8ca8e051d7bb4c17656008419039eaab54ff",
        "snippet": "Deprescribing of evidence-​based medications The deprescribing of medications is not giving up hope, rather it is a proactive, individualized approach that requires a continuous revision of good prescribing principles and takes into consider­ ation the context of goals of care, l",
        "passage_text": "Deprescribing of evidence-​based medications The deprescribing of medications is not giving up hope, rather it is a proactive, individualized approach that requires a continuous revision of good prescribing principles and takes into consider­ ation the context of goals of care, life expectancy, values, and pref­ erences.49 There are several reasons to de-​prescribe, which may include risk of adverse drug event (increased with polypharmacy), limited benefit of evidence-​based medications, and poor adher­ ence to recommended treatment regimen. Professionals may encounter difficulties in discontinuing therapy due to robust pre­ scribing guidelines, the dearth of deprescribing advice, adverse events recurrence after discontinuation, and patient’s medication attachment (https://​depres​crib​ing.org). Many patients will have become familiar with their medication regimen and will have been informed at the time of initiation of the purposes of the medications. Any changes to this regimen will lead to unease and an awareness of declining health. Deprescribing requires profes­ sionals to be sensitive to potential issues and adopt an approach of good communication and information to ensure th",
        "document_type": "textbook",
        "section": "The ESC Textbook of Heart Failure (2024) > p. 766",
        "page_start": 766,
        "page_end": 766,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Essential Geriatrics, 4th Edition (2022) [p. 78]",
        "number": "5",
        "doc_title": "Essential Geriatrics, 4th Edition (2022)",
        "chunk_id": "213d37628ecb7a57d61383baeca6dfb4a196898d066304f3d9bdc10c9facc57f",
        "snippet": "58 Essential Geriatrics MEDICATION OPTIMISATION AND DEPRESCRIBING Medications should be reviewed periodically. This may be part of an annual program or in response to an illness event (e.g. at the time of admission to hospital). The process can be complex for the many reasons dis",
        "passage_text": "58 Essential Geriatrics MEDICATION OPTIMISATION AND DEPRESCRIBING Medications should be reviewed periodically. This may be part of an annual program or in response to an illness event (e.g. at the time of admission to hospital). The process can be complex for the many reasons dis­ cussed in this chapter. An effective medication review is much more than obtaining a complete list of drugs currently prescribed and establishing what the patient is actually taking (i.e. medicine reconciliation). Initial information should also include their indications (e.g. primary or secondary disease prevention) and dura­ tion of use to date. It is necessary to balance benefits and harms, both for individual drugs and the overall effect of thera­ peutic burden. People should be asked about their understanding of the indication for each medication and their desire to continue taking it. It is very common to hear older people complain about the number of medications they are taking and to express a desire to be taking fewer. A reasonable balance often has to be reached between polypharmacy and inappropriate under-prescription. This is likely to be tailored according to individual characteristics, goals",
        "document_type": "textbook",
        "section": "Essential Geriatrics, 4th Edition (2022) > p. 78",
        "page_start": 78,
        "page_end": 78,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Essential Geriatrics, 4th Edition (2022) [pp. 61-62]",
        "number": "6",
        "doc_title": "Essential Geriatrics, 4th Edition (2022)",
        "chunk_id": "973c3e921cc1d6acb7081678838c4a08f1d523770e5db68eeb6dbb25838a17d5",
        "snippet": "Drug-ageing paradox Generally speaking, people at greater risk of disease have a greater absolute risk reduction, and therefore benefit, from medications to prevent future adverse events. However, few frail older people have been evaluated in clinical trials. The traditional appr",
        "passage_text": "Drug-ageing paradox Generally speaking, people at greater risk of disease have a greater absolute risk reduction, and therefore benefit, from medications to prevent future adverse events. However, few frail older people have been evaluated in clinical trials. The traditional approach has been evidence-extrapolated medicine, i.e. the assumption that drugs will work at least as well, possibly better than people in RCTs because morbidity and mortality are more common in old age. However, for the reasons out­ lined previously, lower efficacy and greater risk of adverse effects lead to the drug-ageing paradox; those who take the most medications stand to gain the least from each individual drug.16 42 Essential Geriatrics Shared decision-making Substantial variation in physiological age exists between individuals, related to differences in co-morbidity and physical and cognitive frailty. This requires an individualised approach. Different people attach varying importance to avoiding death, maximising current quality of life or maintaining independence. They also have differing perceptions of therapeutic burden. Guidelines aim to standardise care, which is the opposite of individualised c",
        "document_type": "textbook",
        "section": "Essential Geriatrics, 4th Edition (2022) > pp. 61-62",
        "page_start": 61,
        "page_end": 62,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Harrison's Principles of Internal Medicine, 21st Edition (2022) [p. 3791]",
        "number": "8",
        "doc_title": "Harrison's Principles of Internal Medicine, 21st Edition (2022)",
        "chunk_id": "2660dd37ee15a757c65db38b591a9571113056048e779fb2c8379ee81de0be0a",
        "snippet": "Management Table 477-8 lists several general recommendations for geriatric prescribing that should help make drug therapy more effective and safer in older patients, especially those with multimorbidity. Chapter 67 also provides information on general principles of clinical pharm",
        "passage_text": "Management Table 477-8 lists several general recommendations for geriatric prescribing that should help make drug therapy more effective and safer in older patients, especially those with multimorbidity. Chapter 67 also provides information on general principles of clinical pharmacology. Because these patients often see multiple specialists, the internist should serve as the “quarterback” for all prescribing to help ensure adherence and minimize the potential for adverse drug effects. In hospital, PAC, and LTC settings, clinical pharmacists can be extremely helpful in achieving these recommendations and goals. Muscle weakness, deconditioning Lower extremity strength training Drug adverse effects (e.g., sedatives, alcohol, other psychotropic drugs, antihypertensive) Elimination of drug(s) when feasible Vitamin D deficiency Vitamin D supplementation Recurrent falls Fall alert system for those who live alone; hip protectors in selected patients While undertreatment of certain conditions may occur in older people (such as osteoporosis, depression, and overactive bladder), more attention is now being paid to “deprescribing.” Deprescribing must be done carefully, especially at the time o",
        "document_type": "textbook",
        "section": "Harrison's Principles of Internal Medicine, 21st Edition (2022) > p. 3791",
        "page_start": 3791,
        "page_end": 3791,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Kaplan and Sadock's Comprehensive Textbook of Psychiatry, 11th Edition (2024) [pp. 13641-13642]",
        "number": "11",
        "doc_title": "Kaplan and Sadock's Comprehensive Textbook of Psychiatry, 11th Edition (2024)",
        "chunk_id": "e0afcef5bd19d4666b27bdaa18defc0cb4d3ca51fd9ed58cbc963c69a637c793",
        "snippet": "will require continued attention to establish the most appropriate medication regimen for an older adult individual. Polypharmacy is a significant concern in this population. A survey of community-dwelling older adults (aged 65 years and older) reported that 39.0% of the overall ",
        "passage_text": "will require continued attention to establish the most appropriate medication regimen for an older adult individual. Polypharmacy is a significant concern in this population. A survey of community-dwelling older adults (aged 65 years and older) reported that 39.0% of the overall group surveyed used five or more medications and that the average amount of prescription medication use in this population has doubled over the past three decades, with the most pronounced increases being in males over age 80. In addition, regular use of over-thecounter medications and herbal and dietary supplements are also on the rise in the older adult. An explicit-based guide such as the American Geriatrics Society Beers Criteria or the Screening Tool of Older People’s Prescriptions (STOPP)/Screening Tool to Alert to Right Treatment (START) can be helpful in the clinician’s efforts to evaluate medication regimens and reduce polypharmacy. These are the general guidelines that we recommend when prescribing medications for an older adult patient: Always keep patients’ goals of care, current health, and cognitive status in mind. Before adding a medication, carefully review the current regimen and attempt to",
        "document_type": "textbook",
        "section": "Kaplan and Sadock's Comprehensive Textbook of Psychiatry, 11th Edition (2024) > pp. 13641-13642",
        "page_start": 13641,
        "page_end": 13642,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Behavioral Medicine - A Guide for Clinical Practice, 5th Edition (2020) [p. 166]",
        "number": "12",
        "doc_title": "Behavioral Medicine - A Guide for Clinical Practice, 5th Edition (2020)",
        "chunk_id": "7f88754b8a77c977acc84dce143bd3a5e2101559f517a0e85c1cbada2593fd40",
        "snippet": "drug clearance, often due to naturally reduced renal clearance in older adults. Therefore, dosing must often be reduced. In addition, the volume of distribution for benzodiazepines and opioids is increased in older adults, and thus older adults often have increased sensitiviry to",
        "passage_text": "drug clearance, often due to naturally reduced renal clearance in older adults. Therefore, dosing must often be reduced. In addition, the volume of distribution for benzodiazepines and opioids is increased in older adults, and thus older adults often have increased sensitiviry to these medications due to increased plasma concentrations. Frequent medication review and reduction should be part of the care of every older adult. Deprescribing, whereby medications are either removed or tapered over time, is an essential component of the physician visit with older persons who are taking multiple, often unnecessary medications. The decision to discontinue a medication is not only influenced by the possibility of ADEs, but also by the goals of care for a particular patient. When deprescribing, it is necessary to consider safer alternative medicines, using the lowest possible dose, to remove one medication at a time, and to consider nonpharmacological treatments such as cognitive behavioral therapy for depression and anxiety, stress reduction activities for anxiety, cognitive rehabilitation for mild cognitive impairment, and a change in environment for dementia. Specific criteria have been ",
        "document_type": "textbook",
        "section": "Behavioral Medicine - A Guide for Clinical Practice, 5th Edition (2020) > p. 166",
        "page_start": 166,
        "page_end": 166,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Essential Geriatrics, 4th Edition (2022) [p. 78]",
        "number": "7",
        "doc_title": "Essential Geriatrics, 4th Edition (2022)",
        "chunk_id": "adcb4afd45a0510ca83a3b2405991584f76aff169d9d4720aaf00a863280b32a",
        "snippet": "taken for symptomatic relief, are they getting the desired benefit? For preventive medications, it is important to establish when and why they were started. For some drugs the benefits of continuation may be reduced after several years (e.g. bisphosphonates, see page 341). As dis",
        "passage_text": "taken for symptomatic relief, are they getting the desired benefit? For preventive medications, it is important to establish when and why they were started. For some drugs the benefits of continuation may be reduced after several years (e.g. bisphosphonates, see page 341). As discussed earlier, antiplatelets and statins are unlikely to be beneficial for primary prevention in frail older people. Agents without a clear benefit should be withdrawn. This often occurs at the time of hospital admission when the results of medication adjustments can be closely monitored. Some guidance regarding things to consider is given in Table 3.5. Deprescribing Various definitions of deprescribing have been proposed.16 Essentially, it is a planned process of medication reduction driven by shared decision-making. This can include stopping one or more medications, switching to a more preferable alternative, reducing the dose or changing the formulation (e.g. to a longer-acting version to sim­ plify a medication regime through fewer administration times). Deprescribing may be used to tackle polyphar­ macy but it can also be of value for people on just a few medications. It may improve outcomes but even ",
        "document_type": "textbook",
        "section": "Essential Geriatrics, 4th Edition (2022) > p. 78",
        "page_start": 78,
        "page_end": 78,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Harrison's Principles of Internal Medicine, 21st Edition (2022) [p. 3792]",
        "number": "9",
        "doc_title": "Harrison's Principles of Internal Medicine, 21st Edition (2022)",
        "chunk_id": "42e078509efde7f453bb4d147d454e3546ea240acd07e8c826a387bc4d80ef8e",
        "snippet": "changes, alterations in alertness and attention, and visual hallucinations that can cause paranoia. Although most dementia syndromes are slowly progressive over several years, dementia is a terminal illness among patients who do not succumb to other comorbidities and results in d",
        "passage_text": "changes, alterations in alertness and attention, and visual hallucinations that can cause paranoia. Although most dementia syndromes are slowly progressive over several years, dementia is a terminal illness among patients who do not succumb to other comorbidities and results in devastating loss of cognition and function in the later stages. Careful deprescribing is a critical aspect of person-centered care in the geriatric population. Several general principles, including some in Table 477-8, may assist with deprescribing efforts, including the following: ascertain all drugs the patient is currently taking and the reasons for each one; consider overall risk of drug-induced harm in individual patients in determining the required intensity of deprescribing intervention; assess each drug as to its current or future benefit potential compared with current or future harm or burden potential; prioritize drugs for discontinuation that have the lowest benefitharm ratio and lowest likelihood of adverse withdrawal reactions or disease rebound syndromes; and implement a discontinuation regimen based on the pharmacology of the drug being discontinued and monitor patients closely for improvemen",
        "document_type": "textbook",
        "section": "Harrison's Principles of Internal Medicine, 21st Edition (2022) > p. 3792",
        "page_start": 3792,
        "page_end": 3792,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "Harrison's Principles of Internal Medicine, 21st Edition (2022) [pp. 3791-3792]",
        "number": "10",
        "doc_title": "Harrison's Principles of Internal Medicine, 21st Edition (2022)",
        "chunk_id": "5e7f35a41f83062a39419b4e11ac1630b44f55a4e2fc506cbc2322b482e2f7af",
        "snippet": "Epidemiology and Impact Polypharmacy is defined as the prescription of multiple medications using various thresholds (generally 3751 50 TABLE 477-8 General Recommendations for Geriatric Prescribing 1. Evaluate geriatric patients thoroughly to identify all conditions that could (a",
        "passage_text": "Epidemiology and Impact Polypharmacy is defined as the prescription of multiple medications using various thresholds (generally 3751 50 TABLE 477-8 General Recommendations for Geriatric Prescribing 1. Evaluate geriatric patients thoroughly to identify all conditions that could (a) benefit from drug treatment; (b) be adversely affected by drug treatment; and (c) influence the efficacy of drug treatment. 2. Manage medical conditions without drugs as often as possible. 3. Know the pharmacology of the drug(s) being prescribed. 4. Consider how the clinical status (e.g., renal function, hydration) of each patient could influence the pharmacology of the drug(s). 5. Avoid potentially serious adverse drug-drug interactions. 6. For drugs or their active metabolites eliminated predominantly by the kidney, use a formula to approximate age-related changes in renal function and adjust dosages accordingly; the Cockcroft-Gault formula (below) is probably safer as it tends to underestimate creatinine clearance. 40 Prevalence (%) 30 Men 20 Women 10 − × × × Creatinine clearance= (140 age) body weight (kg) 72 serum creatinine level ( 0.85 for women) 70–74 0 75–79 Age 80–84 85–89 Caring for the Geriatr",
        "document_type": "textbook",
        "section": "Harrison's Principles of Internal Medicine, 21st Edition (2022) > pp. 3791-3792",
        "page_start": 3791,
        "page_end": 3792,
        "_category": "safety",
        "_axis": "patient_factor"
      },
      {
        "source": "The ESC Textbook of Heart Failure (2024) [pp. 31-32]",
        "number": "4",
        "doc_title": "The ESC Textbook of Heart Failure (2024)",
        "chunk_id": "7ee08ec6a02afbb478146b8cbc235b0df96214465ec2fb660d5b94f19898df61",
        "snippet": "Universal definition and classification of heart failure: a report of the Heart Failure Society of America, Heart Failure Association of the European Society of Cardiology, Japanese Heart Failure Society and Writing Committee of the Universal Definition of Heart Failure: Endorsed",
        "passage_text": "Universal definition and classification of heart failure: a report of the Heart Failure Society of America, Heart Failure Association of the European Society of Cardiology, Japanese Heart Failure Society and Writing Committee of the Universal Definition of Heart Failure: Endorsed by the Canadian Heart Failure Society, Heart Failure Association of India, Cardiac Society of Australia and New Zealand, and Chinese Heart Failure Association. Eur J Heart Fail. 2021 Mar;23:352–​380. doi: 10.1002/​ejhf.2115. Reprinted by permission of John Wiley and Sons on behalf of the European Society of Cardiology. SECTION 1 Universal definition of heart failure 6 This four-​stage classification into stages A to D has some ad­ vantages in that it recognizes the progression from risk factors for HF through early asymptomatic disease through to mildly and se­ verely symptomatic disease. The staging system, however, has not been taken up extensively in routine practice and some people have felt it is suggesting that HF is a disease that can occur before symptoms, and this may be argued against the concept of HF as a symptomatic clinical syndrome. The consensus universal def­ inition of HF paper proposes t",
        "document_type": "textbook",
        "section": "The ESC Textbook of Heart Failure (2024) > pp. 31-32",
        "page_start": 31,
        "page_end": 32,
        "_category": "safety",
        "_axis": "organ_comorbid"
      },
      {
        "source": "Standards of Care in Diabetes 2026 - 11. Chronic Kidney Disease and Risk Management (2026) [p. 1]",
        "number": "2",
        "doc_title": "Standards of Care in Diabetes 2026 - 11. Chronic Kidney Disease and Risk Management (2026)",
        "chunk_id": "f6ff40cc7792c38046a2b6eaca82375a18aabd70045dc7155a25edd526a5446e",
        "snippet": "S246 Diabetes Care Volume 49, Supplement 1, January 2026 11. CHRONIC KIDNEY DISEASE AND RISK MANAGEMENT 11. Chronic Kidney Disease and Risk Management: Standards of Care in Diabetes—2026 American Diabetes Association Professional Practice Committee for Diabetes* Diabetes Care 202",
        "passage_text": "S246 Diabetes Care Volume 49, Supplement 1, January 2026 11. CHRONIC KIDNEY DISEASE AND RISK MANAGEMENT 11. Chronic Kidney Disease and Risk Management: Standards of Care in Diabetes—2026 American Diabetes Association Professional Practice Committee for Diabetes* Diabetes Care 2026;49(Suppl. 1):S246–S260 | https://doi.org/10.2337/dc26-S011 The American Diabetes Association (ADA) “Standards of Care in Diabetes” in­ cludes the ADA’s current clinical practice recommendations and is intended to provide the components of diabetes care, general treatment goals and guide­ lines, and tools to evaluate quality of care. Members of the ADA Professional Practice Committee for Diabetes, an interprofessional expert committee, are re­ sponsible for updating the Standards of Care annually, or more frequently as war­ ranted. For a detailed description of ADA standards, statements, and reports, as well as the evidence-grading system for ADA’s clinical practice recommendations and a full list of Professional Practice Committee members, please refer to Introduction and Methodology. Readers who wish to comment on the Standards of Care are invited to do so at professional.diabetes.org/SOC. For prevention",
        "document_type": "guideline",
        "section": "Standards of Care in Diabetes 2026 - 11. Chronic Kidney Disease and Risk Management (2026) > p. 1",
        "page_start": 1,
        "page_end": 1,
        "_category": "safety",
        "_axis": "organ_comorbid"
      },
      {
        "source": "2022 AHA-ACC-HFSA Guideline for the Management of Heart Failure (2022) [p. 5]",
        "number": "1",
        "doc_title": "2022 AHA-ACC-HFSA Guideline for the Management of Heart Failure (2022)",
        "chunk_id": "13667a73e72707acde7afdd90b9cee252f318ee9259cfd418c23499d3ca760b8",
        "snippet": "2022 AHA/ACC/HFSA Heart Failure Guideline PREAMBLE Since 1980, the American College of Cardiology (ACC) and American Heart Association (AHA) have translated scientiﬁc evidence into clinical practice guidelines with recommendations to improve cardiovascular health. These guideline",
        "passage_text": "2022 AHA/ACC/HFSA Heart Failure Guideline PREAMBLE Since 1980, the American College of Cardiology (ACC) and American Heart Association (AHA) have translated scientiﬁc evidence into clinical practice guidelines with recommendations to improve cardiovascular health. These guidelines, which are based on systematic methods to evaluate and classify evidence, provide a foundation for the delivery of quality cardiovascular care. The ACC and AHA sponsor the development and publication of clinical practice guidelines without commercial support, and members volunteer their time to the writing and review efforts. Guidelines are ofﬁcial policy of the ACC and AHA. For some guidelines, the ACC and AHA partner with other organizations. Intended Use Clinical practice guidelines provide recommendations applicable to patients with or at risk of developing cardiovascular disease (CVD). The focus is on medical practice in the United States, but these guidelines are relevant to patients throughout the world. Although guidelines",
        "document_type": "guideline",
        "section": "2022 AHA-ACC-HFSA Guideline for the Management of Heart Failure (2022) > p. 5",
        "page_start": 5,
        "page_end": 5,
        "_category": "safety",
        "_axis": "organ_comorbid"
      },
      {
        "source": "Diabetes - Clinician's Desk Reference (2023) [pp. 122-123]",
        "number": "13",
        "doc_title": "Diabetes - Clinician's Desk Reference (2023)",
        "chunk_id": "fcec7b060aeeb9bd2ea48afbaf57231e5e2ee91acdf09002f7bbb01a40032486",
        "snippet": "Treatment and management ◆ Management of diabetic nephropathy extends from the management of microalbuminuria to prevent disease progression through to the management of ESRD. 107 ◇ The management of diabetic nephropathy is similar to that of other causes of chronic kidney diseas",
        "passage_text": "Treatment and management ◆ Management of diabetic nephropathy extends from the management of microalbuminuria to prevent disease progression through to the management of ESRD. 107 ◇ The management of diabetic nephropathy is similar to that of other causes of chronic kidney disease, with a particular focus on treatment of hypertension (Figure 9.6). Diabetic kidney disease Figure 9.6 Diabetic kidney disease management in primary practice. Algorithm with routes to diagnosis, monitoring, and control. Control of hypertension and hyperglycemia is essential in patients with nephropathy. Angiotensin-converting enzyme inhibitors (ACEIs) and angiotensin-receptor blockers (ARBs) delay the progression of renal disease and have antiproteinuric and renoprotective effects. 108 ◇ Particular attention must be paid to macrovascular risk factors and complications as well as the increased risk of neuropathy and retinopathy in patients with diabetic kidney disease. Diabetic kidney disease Look out for macrovascular risk factors in patients with diabetic renal disease. General therapy ◆ Once renal dysfunction has been established therapy should include: ◇ Phosphate binders such as calcium carbonate. ◇ V",
        "document_type": "textbook",
        "section": "Diabetes - Clinician's Desk Reference (2023) > pp. 122-123",
        "page_start": 122,
        "page_end": 123,
        "_category": "safety",
        "_axis": "organ_comorbid"
      }
    ],
    "guideline_evidence": {
      "categories": [
        {
          "category": "safety",
          "answer": "",
          "evidence_quality": "strong",
          "source_numbers": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49"
          ]
        }
      ],
      "references": [
        {
          "doc_title": "2022 AHA-ACC-HFSA Guideline for the Management of Heart Failure (2022)",
          "document_type": "guideline",
          "passages": [
            {
              "category": "safety",
              "number": "1",
              "snippet": "2022 AHA/ACC/HFSA Heart Failure Guideline PREAMBLE Since 1980, the American College of Cardiology (ACC) and American Heart Association (AHA) have translated scientiﬁc evidence into clinical practice guidelines with recommendations to improve cardiovascular health. These guideline",
              "passage_text": "2022 AHA/ACC/HFSA Heart Failure Guideline PREAMBLE Since 1980, the American College of Cardiology (ACC) and American Heart Association (AHA) have translated scientiﬁc evidence into clinical practice guidelines with recommendations to improve cardiovascular health. These guidelines, which are based on systematic methods to evaluate and classify evidence, provide a foundation for the delivery of quality cardiovascular care. The ACC and AHA sponsor the development and publication of clinical practice guidelines without commercial support, and members volunteer their time to the writing and review efforts. Guidelines are ofﬁcial policy of the ACC and AHA. For some guidelines, the ACC and AHA partner with other organizations. Intended Use Clinical practice guidelines provide recommendations applicable to patients with or at risk of developing cardiovascular disease (CVD). The focus is on medical practice in the United States, but these guidelines are relevant to patients throughout the world. Although guidelines",
              "document_type": "guideline",
              "section": "2022 AHA-ACC-HFSA Guideline for the Management of Heart Failure (2022) > p. 5",
              "page_start": 5,
              "page_end": 5
            }
          ]
        },
        {
          "doc_title": "Standards of Care in Diabetes 2026 - 11. Chronic Kidney Disease and Risk Management (2026)",
          "document_type": "guideline",
          "passages": [
            {
              "category": "safety",
              "number": "2",
              "snippet": "S246 Diabetes Care Volume 49, Supplement 1, January 2026 11. CHRONIC KIDNEY DISEASE AND RISK MANAGEMENT 11. Chronic Kidney Disease and Risk Management: Standards of Care in Diabetes—2026 American Diabetes Association Professional Practice Committee for Diabetes* Diabetes Care 202",
              "passage_text": "S246 Diabetes Care Volume 49, Supplement 1, January 2026 11. CHRONIC KIDNEY DISEASE AND RISK MANAGEMENT 11. Chronic Kidney Disease and Risk Management: Standards of Care in Diabetes—2026 American Diabetes Association Professional Practice Committee for Diabetes* Diabetes Care 2026;49(Suppl. 1):S246–S260 | https://doi.org/10.2337/dc26-S011 The American Diabetes Association (ADA) “Standards of Care in Diabetes” in­ cludes the ADA’s current clinical practice recommendations and is intended to provide the components of diabetes care, general treatment goals and guide­ lines, and tools to evaluate quality of care. Members of the ADA Professional Practice Committee for Diabetes, an interprofessional expert committee, are re­ sponsible for updating the Standards of Care annually, or more frequently as war­ ranted. For a detailed description of ADA standards, statements, and reports, as well as the evidence-grading system for ADA’s clinical practice recommendations and a full list of Professional Practice Committee members, please refer to Introduction and Methodology. Readers who wish to comment on the Standards of Care are invited to do so at professional.diabetes.org/SOC. For prevention",
              "document_type": "guideline",
              "section": "Standards of Care in Diabetes 2026 - 11. Chronic Kidney Disease and Risk Management (2026) > p. 1",
              "page_start": 1,
              "page_end": 1
            }
          ]
        },
        {
          "doc_title": "The ESC Textbook of Heart Failure (2024)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "safety",
              "number": "3",
              "snippet": "Deprescribing of evidence-​based medications The deprescribing of medications is not giving up hope, rather it is a proactive, individualized approach that requires a continuous revision of good prescribing principles and takes into consider­ ation the context of goals of care, l",
              "passage_text": "Deprescribing of evidence-​based medications The deprescribing of medications is not giving up hope, rather it is a proactive, individualized approach that requires a continuous revision of good prescribing principles and takes into consider­ ation the context of goals of care, life expectancy, values, and pref­ erences.49 There are several reasons to de-​prescribe, which may include risk of adverse drug event (increased with polypharmacy), limited benefit of evidence-​based medications, and poor adher­ ence to recommended treatment regimen. Professionals may encounter difficulties in discontinuing therapy due to robust pre­ scribing guidelines, the dearth of deprescribing advice, adverse events recurrence after discontinuation, and patient’s medication attachment (https://​depres​crib​ing.org). Many patients will have become familiar with their medication regimen and will have been informed at the time of initiation of the purposes of the medications. Any changes to this regimen will lead to unease and an awareness of declining health. Deprescribing requires profes­ sionals to be sensitive to potential issues and adopt an approach of good communication and information to ensure th",
              "document_type": "textbook",
              "section": "The ESC Textbook of Heart Failure (2024) > p. 766",
              "page_start": 766,
              "page_end": 766
            },
            {
              "category": "safety",
              "number": "4",
              "snippet": "Universal definition and classification of heart failure: a report of the Heart Failure Society of America, Heart Failure Association of the European Society of Cardiology, Japanese Heart Failure Society and Writing Committee of the Universal Definition of Heart Failure: Endorsed",
              "passage_text": "Universal definition and classification of heart failure: a report of the Heart Failure Society of America, Heart Failure Association of the European Society of Cardiology, Japanese Heart Failure Society and Writing Committee of the Universal Definition of Heart Failure: Endorsed by the Canadian Heart Failure Society, Heart Failure Association of India, Cardiac Society of Australia and New Zealand, and Chinese Heart Failure Association. Eur J Heart Fail. 2021 Mar;23:352–​380. doi: 10.1002/​ejhf.2115. Reprinted by permission of John Wiley and Sons on behalf of the European Society of Cardiology. SECTION 1 Universal definition of heart failure 6 This four-​stage classification into stages A to D has some ad­ vantages in that it recognizes the progression from risk factors for HF through early asymptomatic disease through to mildly and se­ verely symptomatic disease. The staging system, however, has not been taken up extensively in routine practice and some people have felt it is suggesting that HF is a disease that can occur before symptoms, and this may be argued against the concept of HF as a symptomatic clinical syndrome. The consensus universal def­ inition of HF paper proposes t",
              "document_type": "textbook",
              "section": "The ESC Textbook of Heart Failure (2024) > pp. 31-32",
              "page_start": 31,
              "page_end": 32
            }
          ]
        },
        {
          "doc_title": "Essential Geriatrics, 4th Edition (2022)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "safety",
              "number": "5",
              "snippet": "58 Essential Geriatrics MEDICATION OPTIMISATION AND DEPRESCRIBING Medications should be reviewed periodically. This may be part of an annual program or in response to an illness event (e.g. at the time of admission to hospital). The process can be complex for the many reasons dis",
              "passage_text": "58 Essential Geriatrics MEDICATION OPTIMISATION AND DEPRESCRIBING Medications should be reviewed periodically. This may be part of an annual program or in response to an illness event (e.g. at the time of admission to hospital). The process can be complex for the many reasons dis­ cussed in this chapter. An effective medication review is much more than obtaining a complete list of drugs currently prescribed and establishing what the patient is actually taking (i.e. medicine reconciliation). Initial information should also include their indications (e.g. primary or secondary disease prevention) and dura­ tion of use to date. It is necessary to balance benefits and harms, both for individual drugs and the overall effect of thera­ peutic burden. People should be asked about their understanding of the indication for each medication and their desire to continue taking it. It is very common to hear older people complain about the number of medications they are taking and to express a desire to be taking fewer. A reasonable balance often has to be reached between polypharmacy and inappropriate under-prescription. This is likely to be tailored according to individual characteristics, goals",
              "document_type": "textbook",
              "section": "Essential Geriatrics, 4th Edition (2022) > p. 78",
              "page_start": 78,
              "page_end": 78
            },
            {
              "category": "safety",
              "number": "6",
              "snippet": "Drug-ageing paradox Generally speaking, people at greater risk of disease have a greater absolute risk reduction, and therefore benefit, from medications to prevent future adverse events. However, few frail older people have been evaluated in clinical trials. The traditional appr",
              "passage_text": "Drug-ageing paradox Generally speaking, people at greater risk of disease have a greater absolute risk reduction, and therefore benefit, from medications to prevent future adverse events. However, few frail older people have been evaluated in clinical trials. The traditional approach has been evidence-extrapolated medicine, i.e. the assumption that drugs will work at least as well, possibly better than people in RCTs because morbidity and mortality are more common in old age. However, for the reasons out­ lined previously, lower efficacy and greater risk of adverse effects lead to the drug-ageing paradox; those who take the most medications stand to gain the least from each individual drug.16 42 Essential Geriatrics Shared decision-making Substantial variation in physiological age exists between individuals, related to differences in co-morbidity and physical and cognitive frailty. This requires an individualised approach. Different people attach varying importance to avoiding death, maximising current quality of life or maintaining independence. They also have differing perceptions of therapeutic burden. Guidelines aim to standardise care, which is the opposite of individualised c",
              "document_type": "textbook",
              "section": "Essential Geriatrics, 4th Edition (2022) > pp. 61-62",
              "page_start": 61,
              "page_end": 62
            },
            {
              "category": "safety",
              "number": "7",
              "snippet": "taken for symptomatic relief, are they getting the desired benefit? For preventive medications, it is important to establish when and why they were started. For some drugs the benefits of continuation may be reduced after several years (e.g. bisphosphonates, see page 341). As dis",
              "passage_text": "taken for symptomatic relief, are they getting the desired benefit? For preventive medications, it is important to establish when and why they were started. For some drugs the benefits of continuation may be reduced after several years (e.g. bisphosphonates, see page 341). As discussed earlier, antiplatelets and statins are unlikely to be beneficial for primary prevention in frail older people. Agents without a clear benefit should be withdrawn. This often occurs at the time of hospital admission when the results of medication adjustments can be closely monitored. Some guidance regarding things to consider is given in Table 3.5. Deprescribing Various definitions of deprescribing have been proposed.16 Essentially, it is a planned process of medication reduction driven by shared decision-making. This can include stopping one or more medications, switching to a more preferable alternative, reducing the dose or changing the formulation (e.g. to a longer-acting version to sim­ plify a medication regime through fewer administration times). Deprescribing may be used to tackle polyphar­ macy but it can also be of value for people on just a few medications. It may improve outcomes but even ",
              "document_type": "textbook",
              "section": "Essential Geriatrics, 4th Edition (2022) > p. 78",
              "page_start": 78,
              "page_end": 78
            }
          ]
        },
        {
          "doc_title": "Harrison's Principles of Internal Medicine, 21st Edition (2022)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "safety",
              "number": "8",
              "snippet": "Management Table 477-8 lists several general recommendations for geriatric prescribing that should help make drug therapy more effective and safer in older patients, especially those with multimorbidity. Chapter 67 also provides information on general principles of clinical pharm",
              "passage_text": "Management Table 477-8 lists several general recommendations for geriatric prescribing that should help make drug therapy more effective and safer in older patients, especially those with multimorbidity. Chapter 67 also provides information on general principles of clinical pharmacology. Because these patients often see multiple specialists, the internist should serve as the “quarterback” for all prescribing to help ensure adherence and minimize the potential for adverse drug effects. In hospital, PAC, and LTC settings, clinical pharmacists can be extremely helpful in achieving these recommendations and goals. Muscle weakness, deconditioning Lower extremity strength training Drug adverse effects (e.g., sedatives, alcohol, other psychotropic drugs, antihypertensive) Elimination of drug(s) when feasible Vitamin D deficiency Vitamin D supplementation Recurrent falls Fall alert system for those who live alone; hip protectors in selected patients While undertreatment of certain conditions may occur in older people (such as osteoporosis, depression, and overactive bladder), more attention is now being paid to “deprescribing.” Deprescribing must be done carefully, especially at the time o",
              "document_type": "textbook",
              "section": "Harrison's Principles of Internal Medicine, 21st Edition (2022) > p. 3791",
              "page_start": 3791,
              "page_end": 3791
            },
            {
              "category": "safety",
              "number": "9",
              "snippet": "changes, alterations in alertness and attention, and visual hallucinations that can cause paranoia. Although most dementia syndromes are slowly progressive over several years, dementia is a terminal illness among patients who do not succumb to other comorbidities and results in d",
              "passage_text": "changes, alterations in alertness and attention, and visual hallucinations that can cause paranoia. Although most dementia syndromes are slowly progressive over several years, dementia is a terminal illness among patients who do not succumb to other comorbidities and results in devastating loss of cognition and function in the later stages. Careful deprescribing is a critical aspect of person-centered care in the geriatric population. Several general principles, including some in Table 477-8, may assist with deprescribing efforts, including the following: ascertain all drugs the patient is currently taking and the reasons for each one; consider overall risk of drug-induced harm in individual patients in determining the required intensity of deprescribing intervention; assess each drug as to its current or future benefit potential compared with current or future harm or burden potential; prioritize drugs for discontinuation that have the lowest benefitharm ratio and lowest likelihood of adverse withdrawal reactions or disease rebound syndromes; and implement a discontinuation regimen based on the pharmacology of the drug being discontinued and monitor patients closely for improvemen",
              "document_type": "textbook",
              "section": "Harrison's Principles of Internal Medicine, 21st Edition (2022) > p. 3792",
              "page_start": 3792,
              "page_end": 3792
            },
            {
              "category": "safety",
              "number": "10",
              "snippet": "Epidemiology and Impact Polypharmacy is defined as the prescription of multiple medications using various thresholds (generally 3751 50 TABLE 477-8 General Recommendations for Geriatric Prescribing 1. Evaluate geriatric patients thoroughly to identify all conditions that could (a",
              "passage_text": "Epidemiology and Impact Polypharmacy is defined as the prescription of multiple medications using various thresholds (generally 3751 50 TABLE 477-8 General Recommendations for Geriatric Prescribing 1. Evaluate geriatric patients thoroughly to identify all conditions that could (a) benefit from drug treatment; (b) be adversely affected by drug treatment; and (c) influence the efficacy of drug treatment. 2. Manage medical conditions without drugs as often as possible. 3. Know the pharmacology of the drug(s) being prescribed. 4. Consider how the clinical status (e.g., renal function, hydration) of each patient could influence the pharmacology of the drug(s). 5. Avoid potentially serious adverse drug-drug interactions. 6. For drugs or their active metabolites eliminated predominantly by the kidney, use a formula to approximate age-related changes in renal function and adjust dosages accordingly; the Cockcroft-Gault formula (below) is probably safer as it tends to underestimate creatinine clearance. 40 Prevalence (%) 30 Men 20 Women 10 − × × × Creatinine clearance= (140 age) body weight (kg) 72 serum creatinine level ( 0.85 for women) 70–74 0 75–79 Age 80–84 85–89 Caring for the Geriatr",
              "document_type": "textbook",
              "section": "Harrison's Principles of Internal Medicine, 21st Edition (2022) > pp. 3791-3792",
              "page_start": 3791,
              "page_end": 3792
            }
          ]
        },
        {
          "doc_title": "Kaplan and Sadock's Comprehensive Textbook of Psychiatry, 11th Edition (2024)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "safety",
              "number": "11",
              "snippet": "will require continued attention to establish the most appropriate medication regimen for an older adult individual. Polypharmacy is a significant concern in this population. A survey of community-dwelling older adults (aged 65 years and older) reported that 39.0% of the overall ",
              "passage_text": "will require continued attention to establish the most appropriate medication regimen for an older adult individual. Polypharmacy is a significant concern in this population. A survey of community-dwelling older adults (aged 65 years and older) reported that 39.0% of the overall group surveyed used five or more medications and that the average amount of prescription medication use in this population has doubled over the past three decades, with the most pronounced increases being in males over age 80. In addition, regular use of over-thecounter medications and herbal and dietary supplements are also on the rise in the older adult. An explicit-based guide such as the American Geriatrics Society Beers Criteria or the Screening Tool of Older People’s Prescriptions (STOPP)/Screening Tool to Alert to Right Treatment (START) can be helpful in the clinician’s efforts to evaluate medication regimens and reduce polypharmacy. These are the general guidelines that we recommend when prescribing medications for an older adult patient: Always keep patients’ goals of care, current health, and cognitive status in mind. Before adding a medication, carefully review the current regimen and attempt to",
              "document_type": "textbook",
              "section": "Kaplan and Sadock's Comprehensive Textbook of Psychiatry, 11th Edition (2024) > pp. 13641-13642",
              "page_start": 13641,
              "page_end": 13642
            }
          ]
        },
        {
          "doc_title": "Behavioral Medicine - A Guide for Clinical Practice, 5th Edition (2020)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "safety",
              "number": "12",
              "snippet": "drug clearance, often due to naturally reduced renal clearance in older adults. Therefore, dosing must often be reduced. In addition, the volume of distribution for benzodiazepines and opioids is increased in older adults, and thus older adults often have increased sensitiviry to",
              "passage_text": "drug clearance, often due to naturally reduced renal clearance in older adults. Therefore, dosing must often be reduced. In addition, the volume of distribution for benzodiazepines and opioids is increased in older adults, and thus older adults often have increased sensitiviry to these medications due to increased plasma concentrations. Frequent medication review and reduction should be part of the care of every older adult. Deprescribing, whereby medications are either removed or tapered over time, is an essential component of the physician visit with older persons who are taking multiple, often unnecessary medications. The decision to discontinue a medication is not only influenced by the possibility of ADEs, but also by the goals of care for a particular patient. When deprescribing, it is necessary to consider safer alternative medicines, using the lowest possible dose, to remove one medication at a time, and to consider nonpharmacological treatments such as cognitive behavioral therapy for depression and anxiety, stress reduction activities for anxiety, cognitive rehabilitation for mild cognitive impairment, and a change in environment for dementia. Specific criteria have been ",
              "document_type": "textbook",
              "section": "Behavioral Medicine - A Guide for Clinical Practice, 5th Edition (2020) > p. 166",
              "page_start": 166,
              "page_end": 166
            }
          ]
        },
        {
          "doc_title": "Diabetes - Clinician's Desk Reference (2023)",
          "document_type": "textbook",
          "passages": [
            {
              "category": "safety",
              "number": "13",
              "snippet": "Treatment and management ◆ Management of diabetic nephropathy extends from the management of microalbuminuria to prevent disease progression through to the management of ESRD. 107 ◇ The management of diabetic nephropathy is similar to that of other causes of chronic kidney diseas",
              "passage_text": "Treatment and management ◆ Management of diabetic nephropathy extends from the management of microalbuminuria to prevent disease progression through to the management of ESRD. 107 ◇ The management of diabetic nephropathy is similar to that of other causes of chronic kidney disease, with a particular focus on treatment of hypertension (Figure 9.6). Diabetic kidney disease Figure 9.6 Diabetic kidney disease management in primary practice. Algorithm with routes to diagnosis, monitoring, and control. Control of hypertension and hyperglycemia is essential in patients with nephropathy. Angiotensin-converting enzyme inhibitors (ACEIs) and angiotensin-receptor blockers (ARBs) delay the progression of renal disease and have antiproteinuric and renoprotective effects. 108 ◇ Particular attention must be paid to macrovascular risk factors and complications as well as the increased risk of neuropathy and retinopathy in patients with diabetic kidney disease. Diabetic kidney disease Look out for macrovascular risk factors in patients with diabetic renal disease. General therapy ◆ Once renal dysfunction has been established therapy should include: ◇ Phosphate binders such as calcium carbonate. ◇ V",
              "document_type": "textbook",
              "section": "Diabetes - Clinician's Desk Reference (2023) > pp. 122-123",
              "page_start": 122,
              "page_end": 123
            }
          ]
        }
      ],
      "review_incomplete": false,
      "retrieval_quality": {}
    }
  }
];
